<template>
  <v-container fluid class="dashboard-container pa-6">
    <v-flex xs12 sm12 md12 lg12 v-if="companyobj.vigilante">
      <!-- Header do Dashboard de Vigilantes -->
      <v-row class="mb-6">
        <v-col cols="12" sm="12" md="8">
          <h1 class="text-h4 font-weight-bold grey--text text--darken-3">
            Dashboard - AiCheckin
          </h1>
          <p class="text-subtitle-1 grey--text mb-0">
            Gerenciamento de vigilantes e equipe de apoio
          </p>
        </v-col>
        <v-col cols="12" sm="12" md="4" class="d-flex align-center justify-end">
          <v-btn icon class="mr-2 dark-mode-toggle" @click="toggleDarkMode">
            <v-icon>{{ darkMode ? 'mdi-weather-sunny' : 'mdi-weather-night' }}</v-icon>
          </v-btn>
          <v-btn icon class="mr-2" @click="refreshData">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-btn color="primary" class="ml-2" outlined>
            <v-icon left>mdi-file-export</v-icon>
            Exportar Relatório
          </v-btn>
        </v-col>
      </v-row>

      <!-- Cards Principais de Vigilantes -->
      <v-row>
        <!-- Card de Vigilantes -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-lg purple-gradient elevation-custom-1" elevation="0">
            <v-card-text class="pa-4">
              <div class="d-flex justify-space-between align-center mb-2">
              <div>
                  <p class="text-subtitle-2 white--text mb-1">Vigilantes</p>
                  <p class="text-h4 font-weight-bold mb-0 white--text">{{ qtdVigilantes }}</p>
              </div>
                <v-avatar color="rgba(255,255,255,0.2)" size="48" class="elevation-1">
                  <v-icon dark>mdi-shield-account</v-icon>
              </v-avatar>
            </div>
              <v-progress-linear
                :value="100"
                color="white"
                height="4"
                rounded
              ></v-progress-linear>
              <p class="caption white--text text--darken-1 mt-2 mb-0">
                Total de vigilantes cadastrados
              </p>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Card de Apoio -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-lg amber-gradient elevation-custom-1" elevation="0">
            <v-card-text class="pa-4">
              <div class="d-flex justify-space-between align-center mb-2">
              <div>
                  <p class="text-subtitle-2 white--text mb-1">Apoio</p>
                  <p class="text-h4 font-weight-bold mb-0 white--text">{{ qtdApoio }}</p>
              </div>
                <v-avatar color="rgba(255,255,255,0.2)" size="48" class="elevation-1">
                  <v-icon dark>mdi-account-group</v-icon>
              </v-avatar>
            </div>
              <v-progress-linear
                :value="percentualApoio"
                color="white"
                height="4"
                rounded
              ></v-progress-linear>
              <p class="caption white--text text--darken-1 mt-2 mb-0">
                {{ percentualApoio.toFixed(1) }}% do total da equipe
              </p>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Card de Vigilantes Básico -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-lg green-gradient elevation-custom-1" elevation="0">
            <v-card-text class="pa-4">
              <div class="d-flex justify-space-between align-center mb-2">
              <div>
                  <p class="text-subtitle-2 white--text mb-1">Vigilantes Básico</p>
                  <p class="text-h4 font-weight-bold mb-0 white--text">{{ qtdBasico }}</p>
              </div>
                <v-avatar color="rgba(255,255,255,0.2)" size="48" class="elevation-1">
                  <v-icon dark>mdi-shield</v-icon>
              </v-avatar>
            </div>
              <v-progress-linear
                :value="percentualBasico"
                color="white"
                height="4"
                rounded
              ></v-progress-linear>
              <p class="caption white--text text--darken-1 mt-2 mb-0">
                {{ percentualBasico.toFixed(1) }}% dos vigilantes
              </p>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Card de Em Análise -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-lg blue-gradient elevation-custom-1" elevation="0">
            <v-card-text class="pa-4">
              <div class="d-flex justify-space-between align-center mb-2">
              <div>
                  <p class="text-subtitle-2 white--text mb-1">Em Análise</p>
                  <p class="text-h4 font-weight-bold mb-0 white--text">{{ qtdEmAnalise }}</p>
              </div>
                <v-avatar color="rgba(255,255,255,0.2)" size="48" class="elevation-1">
                  <v-icon dark>mdi-clock-outline</v-icon>
              </v-avatar>
            </div>
              <v-progress-linear
                :value="percentualEmAnalise"
                color="white"
                height="4"
                rounded
              ></v-progress-linear>
              <p class="caption white--text text--darken-1 mt-2 mb-0">
                {{ percentualEmAnalise.toFixed(1) }}% dos vigilantes
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Gráficos e Estatísticas -->
      <v-row class="mt-6">
        <!-- Gráfico de Distribuição de Vigilantes -->
        <v-col cols="12" md="8">
          <v-card class="rounded-lg elevation-custom-1" elevation="0">
            <v-card-title class="text-subtitle-1 font-weight-bold d-flex align-center">
              <v-icon left color="primary" class="mr-2">mdi-chart-pie</v-icon>
              Distribuição por Categoria
              <v-spacer></v-spacer>
              <v-btn icon small class="ml-2">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row align="center" justify="center">
                <v-col cols="12" md="6">
                  <v-sheet class="pa-2">
                    <v-sparkline
                      :value="[qtdVigilantes, qtdApoio, qtdBasico, qtdEmAnalise]"
                      :labels="['Total', 'Apoio', 'Básico', 'Em Análise']"
                      :gradient="['#5D4FEB', '#FF9800', '#0CCE6B', '#607D8B']"
                      :gradient-direction="'top'"
                      padding="16"
                      line-width="3"
                      stroke-linecap="round"
                      smooth
                      auto-draw
                      auto-draw-duration="2000"
                      auto-line-width
                      show-labels
                      label-size="6"
                    ></v-sparkline>
                  </v-sheet>
                </v-col>
                <v-col cols="12" md="6">
                  <v-sheet class="pa-2 d-flex flex-column align-center">
                    <v-progress-circular
                      :size="150"
                      :width="15"
                      :value="percentualApoio"
                      color="amber darken-2"
                      class="mb-3"
                    >
                      {{ percentualApoio.toFixed(0) }}%
                    </v-progress-circular>
                    <p class="text-center text-subtitle-2 grey--text text--darken-1">
                      Apoio vs. Vigilantes
                    </p>
                    
                    <v-row class="mt-4">
                      <v-col cols="6" class="text-center">
                        <v-chip small label color="purple" text-color="white">Aprovados</v-chip>
                        <p class="mt-1 mb-0 caption">{{ qtdVigilantes - qtdEmAnalise }}</p>
                      </v-col>
                      <v-col cols="6" class="text-center">
                        <v-chip small label color="blue-grey" text-color="white">Pendentes</v-chip>
                        <p class="mt-1 mb-0 caption">{{ qtdEmAnalise }}</p>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Status e Ações -->
        <v-col cols="12" md="4">
          <v-card class="rounded-lg elevation-custom-1" elevation="0">
            <v-card-title class="text-subtitle-1 font-weight-bold d-flex align-center">
              <v-icon left color="primary" class="mr-2">mdi-clipboard-list</v-icon>
              Status e Ações
              <v-spacer></v-spacer>
              <v-btn icon small class="ml-2">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="pt-4">
              <v-list dense class="pa-0">
                <v-list-item class="px-0">
                  <v-list-item-avatar>
                    <v-avatar color="success" size="40">
                      <v-icon dark>mdi-check-circle</v-icon>
              </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">{{ qtdVigilantes - qtdEmAnalise }} vigilantes</v-list-item-title>
                    <v-list-item-subtitle>Aprovados</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="px-0 mt-4">
                  <v-list-item-avatar>
                    <v-avatar color="warning" size="40">
                      <v-icon dark>mdi-alert-circle</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">{{ qtdEmAnalise }} vigilantes</v-list-item-title>
                    <v-list-item-subtitle>Pendentes</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider class="my-4"></v-divider>

                <v-btn block color="primary" class="elevation-2 mt-2 text-none" height="44">
                  <v-icon left>mdi-account-plus</v-icon>
                  Adicionar Vigilante
                </v-btn>

                <v-btn block outlined color="secondary" class="mt-4 text-none" height="44">
                  <v-icon left>mdi-file-document</v-icon>
                  Gerar Relatório
                </v-btn>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Botão de Ação Flutuante -->
      <v-speed-dial
        v-model="fabVigilante"
        fixed
        bottom
        right
        direction="left"
        transition="slide-y-reverse-transition"
      >
            <template v-slot:activator>
          <v-btn v-model="fabVigilante" color="purple darken-2" dark fab>
            <v-icon v-if="fabVigilante">mdi-close</v-icon>
            <v-icon v-else>mdi-swap-vertical</v-icon>
              </v-btn>
            </template>

        <v-btn fab dark color="success">
          <v-icon>mdi-account-plus</v-icon>
                </v-btn>

        <v-btn fab dark color="info">
          <v-icon>mdi-file-export</v-icon>
                </v-btn>

        <v-btn fab dark color="warning">
          <v-icon>mdi-refresh</v-icon>
                </v-btn>
          </v-speed-dial>
    </v-flex>

    <v-flex xs12 sm12 md12 lg12 v-else>
      <!-- Header do Dashboard de Eventos -->
      <v-row class="mb-4">
        <v-col cols="12" class="header-container">
          <div class="d-flex flex-column align-center">
            <v-chip small color="success" class="mb-2" label>
              <v-icon left small>mdi-check-circle</v-icon>
              Atualizado
            </v-chip>
            
            <div class="d-flex align-center w-100 mb-4" style="max-width: 350px;">
              <v-select
                v-model="eventoId"
                :items="itensOrdenados"
                item-text="nome"
                item-value="id"
                label="Selecione o Evento"
                @input="carregaValores()"
                color="primary"
                class="event-selector mb-2"
                hide-details
                prepend-inner-icon="mdi-calendar-check"
                menu-props="{ offsetY: true, transition: 'slide-y-transition', minWidth: '350px', rounded: true }"
                rounded
                filled
                single-line
                :loading="carregandoDados"
                return-object
              ></v-select>
            </div>

            <v-chip 
              class="capacity-chip" 
              color="primary"
              v-if="capacidade"
              outlined
            >
              <v-icon left small>mdi-account-group</v-icon>
              Capacidade: {{ capacidade }} vagas
            </v-chip>
            
            <!-- Novo filtro de período compacto -->
            <div class="d-flex align-center justify-center mt-2 mb-3" style="max-width: 350px;">
              <!-- Badge do filtro ativo -->
              <v-menu
                v-model="menuFiltro"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="300"
                rounded="lg"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    :color="periodoFiltro !== 'todos' ? 'primary' : 'grey lighten-1'"
                    :outlined="periodoFiltro === 'todos'"
                    v-bind="attrs"
                    v-on="on"
                    class="period-filter-chip"
                    pill
                  >
                    <v-icon left small>{{ periodoFiltro !== 'todos' ? 'mdi-filter' : 'mdi-filter-outline' }}</v-icon>
                    {{ periodoFiltro === 'todos' ? 'Filtrar período' : periodoAtivo }}
                    <v-icon right x-small>mdi-chevron-down</v-icon>
                  </v-chip>
                </template>
                <v-card class="pa-2">
                  <v-card-title class="text-subtitle-1 px-3 pt-3 pb-1">
                    <v-icon small color="primary" class="mr-2">mdi-clock-time-four-outline</v-icon>
                    Filtrar por período
                  </v-card-title>
                  <v-divider class="blue-divider mb-2"></v-divider>
                  
                  <v-list dense nav>
                    <v-list-item
                      v-for="(opcao, index) in opcoesPeriodo"
                      :key="index"
                      @click="selecionarPeriodo(opcao.valor)"
                      :class="{'primary--text': periodoFiltro === opcao.valor, 'selected-period': periodoFiltro === opcao.valor}"
                    >
                      <v-list-item-icon>
                        <v-icon small :color="periodoFiltro === opcao.valor ? 'primary' : ''">
                          {{ getPeriodIcon(opcao.valor) }}
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ opcao.texto }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action v-if="periodoFiltro === opcao.valor">
                        <v-icon small color="primary">mdi-check</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  
                  <div v-if="periodoFiltro === 'personalizado'" class="px-3 py-2">
                    <v-date-picker
                      v-model="datasFiltro"
                      range
                      no-title
                      scrollable
                      locale="pt-BR"
                      class="mt-2"
                      width="100%"
                      color="primary"
                      first-day-of-week="1"
                      @change="datasFiltro.length === 2 && atualizarPeriodoPersonalizado()"
                    ></v-date-picker>
                  </div>
                  
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      small
                      color="grey darken-1"
                      @click="limparFiltro"
                      :disabled="periodoFiltro === 'todos'"
                    >
                      <v-icon left x-small>mdi-close</v-icon>
                      Limpar filtro
                    </v-btn>
                    <v-btn
                      text
                      small
                      color="primary"
                      @click="menuFiltro = false"
                    >
                      Fechar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Cards Principais -->
      <v-row class="cards-grid" dense>
        <!-- Card de Vagas Reservadas -->
        <v-col cols="6" sm="6" md="3">
          <v-card class="rounded-lg teal-gradient elevation-custom-1 compact-card" elevation="0">
            <v-card-text class="pa-2">
              <div class="d-flex justify-space-between align-center mb-1">
                <div>
                  <p class="text-caption white--text mb-0">Reservadas</p>
                  <p class="text-h6 font-weight-bold mb-0 white--text">{{ reservados }}</p>
                </div>
                <v-avatar color="rgba(255,255,255,0.2)" size="32" class="elevation-1">
                  <v-icon dark size="16">mdi-bookmark-check</v-icon>
                </v-avatar>
              </div>
              <v-progress-linear
                :value="capacidade > 0 ? (reservados / capacidade) * 100 : 0"
                color="white"
                height="3"
                rounded
              ></v-progress-linear>
              <p class="caption white--text text--darken-1 mt-1 mb-0 text-caption">
                {{ capacidade > 0 ? ((reservados / capacidade) * 100).toFixed(1) : '0.0' }}% total
              </p>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Card de Inscritos -->
        <v-col cols="6" sm="6" md="3">
          <v-card class="rounded-lg green-gradient elevation-custom-1 compact-card" elevation="0">
            <v-card-text class="pa-2">
              <div class="d-flex justify-space-between align-center mb-1">
                <div>
                  <p class="text-caption white--text mb-0">Inscritos</p>
                  <p class="text-h6 font-weight-bold mb-0 white--text">{{ inscritos }}</p>
                </div>
                <v-avatar color="rgba(255,255,255,0.2)" size="32" class="elevation-1">
                  <v-icon dark size="16">mdi-account-check</v-icon>
                </v-avatar>
              </div>
              <v-progress-linear
                :value="percentInscri"
                color="white"
                height="3"
                rounded
              ></v-progress-linear>
              <p class="caption white--text text--darken-1 mt-1 mb-0 text-caption">
                {{ percentInscri.toFixed(1) }}% total
              </p>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Card de Confirmados -->
        <v-col cols="6" sm="6" md="3">
          <v-card class="rounded-lg blue-gradient elevation-custom-1 compact-card" elevation="0">
            <v-card-text class="pa-2">
              <div class="d-flex justify-space-between align-center mb-1">
                <div>
                  <p class="text-caption white--text mb-0">Confirmados</p>
                  <p class="text-h6 font-weight-bold mb-0 white--text">{{ inscritosPagos }}</p>
                </div>
                <v-avatar color="rgba(255,255,255,0.2)" size="32" class="elevation-1">
                  <v-icon dark size="16">mdi-account-cash</v-icon>
                </v-avatar>
              </div>
              <v-progress-linear
                :value="percentConfirm"
                color="white"
                height="3"
                rounded
              ></v-progress-linear>
              <p class="caption white--text text--darken-1 mt-1 mb-0 text-caption">
                {{ percentConfirm.toFixed(1) }}% total
              </p>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Card de Check-ins -->
        <v-col cols="6" sm="6" md="3">
          <v-card class="rounded-lg amber-gradient elevation-custom-1 compact-card" elevation="0">
            <v-card-text class="pa-2">
              <div class="d-flex justify-space-between align-center mb-1">
                <div>
                  <p class="text-caption white--text mb-0">Check-ins</p>
                  <p class="text-h6 font-weight-bold mb-0 white--text">{{ checkinsRealizadosTotal }}</p>
                </div>
                <v-avatar color="rgba(255,255,255,0.2)" size="32" class="elevation-1">
                  <v-icon dark size="16">mdi-check-circle</v-icon>
                </v-avatar>
              </div>
              <v-progress-linear
                :value="percentCheckinTotal"
                color="white"
                height="3"
                rounded
              ></v-progress-linear>
              <p class="caption white--text text--darken-1 mt-1 mb-0 text-caption">
                {{ percentCheckinTotal.toFixed(1) }}% conf.
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Card de Valor Confirmado -->
      <!-- <v-row class="mt-3">
        <v-col cols="12">
          <v-card class="rounded-lg valor-confirmado-card elevation-custom-1" elevation="0">
            <v-card-text class="pa-4">
              <v-row align="center">
                <v-col cols="12" sm="6" md="8">
                  <div class="d-flex align-center">
                    <v-avatar color="rgba(33,150,243,0.15)" size="52" class="mr-4">
                      <v-icon size="28" color="#2196F3">mdi-cash-register</v-icon>
                    </v-avatar>
                    <div>
                      <p class="text-subtitle-1 blue--text text--darken-1 mb-1 font-weight-medium">TOTAL EM VENDAS</p>
                      <div class="d-flex align-center">
                        <p class="text-h4 font-weight-bold mb-0 black--text" v-if="!ocultarValores">{{ formatarMoeda(valorPago) }}</p>
                        <p class="text-h4 font-weight-bold mb-0 black--text" v-else>••••••</p>
                        <v-btn
                          icon
                          x-small
                          class="ml-2 mt-1 eye-btn"
                          @click="ocultarValores = !ocultarValores"
                          :title="ocultarValores ? 'Mostrar valores' : 'Ocultar valores'"
                        >
                          <v-icon size="18">{{ ocultarValores ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div class="d-flex flex-column">
                    <div class="d-flex justify-space-between align-center mb-1">
                      <span class="caption blue--text text--darken-1">Valor médio por inscrição:</span>
                      <span class="body-2 font-weight-medium" v-if="!ocultarValores">{{ formatarMoeda(valorPago / inscritosPagos) }}</span>
                      <span class="body-2 font-weight-medium" v-else>••••••</span>
                    </div>
                    <v-divider class="my-2 blue-divider"></v-divider>
                    <div class="d-flex justify-space-between align-center">
                      <span class="caption blue--text text--darken-1">Inscrições confirmadas:</span>
                      <span class="body-2 font-weight-medium">{{ inscritosPagos }}</span>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row> -->
      
      <!-- Formas de Pagamento (Após TOTAL EM VENDAS) -->
      <!-- <v-row class="mt-2" v-if="valorPago > 0">
        <v-col cols="12">
          <v-card class="rounded-lg elevation-custom-1 payment-methods-card" elevation="0">
            <v-card-title class="text-subtitle-1 font-weight-bold d-flex align-center">
              <v-icon left color="#2196F3" class="mr-2">mdi-cash-multiple</v-icon>
              <span class="blue--text text--darken-1">Formas de Pagamento</span>
              <v-spacer></v-spacer>
              <v-btn icon small @click="refreshData" class="ml-2">
                <v-icon color="blue lighten-1">mdi-refresh</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <div v-for="(forma, index) in formasPagamentoValidas" :key="index" class="payment-method-item mb-4">
                <div class="d-flex align-center mb-1">
                  <v-avatar :color="getPaymentColor(index)" size="32" class="mr-3 pix-avatar">
                    <template v-if="forma.tipo === 'PIX'">
                      <img src="../assets/pixwhite.png" alt="PIX" width="18" height="18" class="pix-icon">
                    </template>
                    <v-icon dark v-else>{{ getPaymentIcon(forma.tipo) }}</v-icon>
                  </v-avatar>
                  <span class="subtitle-1 font-weight-medium">{{ forma.tipo }}</span>
                  <v-spacer></v-spacer>
                  <span class="subtitle-1 font-weight-bold" v-if="!ocultarValores">{{ formatarMoeda(forma.valor) }}</span>
                  <span class="subtitle-1 font-weight-bold" v-else>••••••</span>
                </div>
                <div class="d-flex justify-space-between mb-1">
                  <span class="caption blue--text text--darken-1">Transações: <span class="black--text">{{ forma.quantidade }}</span></span>
                  <span class="caption blue--text text--darken-1">
                    <span v-if="!ocultarValores">{{ ((forma.valor / valorPago) * 100).toFixed(1) }}%</span>
                    <span v-else>••%</span>
                  </span>
                </div>
                <v-progress-linear
                  :value="(forma.valor / valorPago) * 100"
                  :color="getPaymentColor(index)"
                  height="8"
                  rounded
                ></v-progress-linear>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row> -->

      <!-- Gráficos e Informações Detalhadas -->
      <v-row class="mt-3">
        <!-- Gráfico de Distribuição -->
        <v-col cols="12" md="8">
          <v-card max-height="370" class="rounded-lg elevation-custom-1" elevation="0">
            <v-card-title class="text-subtitle-1 font-weight-bold d-flex align-center">
              <v-icon left color="primary" class="mr-2">mdi-chart-bar</v-icon>
              Distribuição de Participantes
              <v-spacer></v-spacer>
              <v-btn icon small class="ml-2">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-sparkline
                :value="[capacidade, inscritos, inscritosPagos, checkinsRealizadosTotal]"
                :labels="[]"
                :gradient="['#5D4FEB', '#0CCE6B', '#2196F3', '#FF9800']"
                :gradient-direction="'top'"
                padding="16"
                line-width="2.5"
                stroke-linecap="round"
                smooth
                auto-draw
                auto-draw-duration="2000"
                auto-line-width
                class="mt-2"
                height="73"
              ></v-sparkline>
              
              <v-row class="mt-3" dense>
                <v-col cols="3" class="text-center">
                  <v-chip x-small label color="primary" text-color="white">Capacidade</v-chip>
                  <p class="mt-1 mb-0 caption font-weight-medium">{{ capacidade }}</p>
                </v-col>
                <v-col cols="3" class="text-center">
                  <v-chip x-small label color="success" text-color="white">Inscritos</v-chip>
                  <p class="mt-1 mb-0 caption font-weight-medium">{{ inscritos }}</p>
                </v-col>
                <v-col cols="3" class="text-center">
                  <v-chip x-small label color="info" text-color="white">Confirmados</v-chip>
                  <p class="mt-1 mb-0 caption font-weight-medium">{{ inscritosPagos }}</p>
                </v-col>
                <v-col cols="3" class="text-center">
                  <v-chip x-small label color="warning" text-color="white">Check-ins</v-chip>
                  <p class="mt-1 mb-0 caption font-weight-medium">{{ checkinsRealizadosTotal }}</p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Informações do Evento -->
        <v-col cols="12" md="4">
          <v-card class="rounded-lg elevation-custom-1" elevation="0">
            <v-card-title class="text-subtitle-1 font-weight-bold d-flex align-center">
              <v-icon left color="primary" class="mr-2">mdi-information</v-icon>
              Informações do Evento
              <v-spacer></v-spacer>
              <v-btn icon small class="ml-2">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="pt-4">
              <v-list dense class="pa-0">
                <v-list-item v-if="eventoSelecionado.nome" class="px-0">
                  <v-list-item-avatar>
                    <v-avatar color="primary" size="40">
                      <v-icon dark>mdi-tag</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">{{ eventoSelecionado.nome }}</v-list-item-title>
                    <v-list-item-subtitle>Nome do Evento</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="eventoSelecionado.inicio" class="px-0 mt-4">
                  <v-list-item-avatar>
                    <v-avatar color="success" size="40">
                      <v-icon dark>mdi-calendar-start</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">{{ formatDateHora(eventoSelecionado.inicio) }}</v-list-item-title>
                    <v-list-item-subtitle>Data de Início</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="eventoSelecionado.fim" class="px-0 mt-4">
                  <v-list-item-avatar>
                    <v-avatar color="error" size="40">
                      <v-icon dark>mdi-calendar-end</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">{{ formatDateHora(eventoSelecionado.fim) }}</v-list-item-title>
                    <v-list-item-subtitle>Data de Término</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="px-0 mt-4">
                  <v-list-item-avatar>
                    <v-avatar color="warning" size="40">
                      <v-icon dark>mdi-ticket-percent</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">{{ qtdIngressosFisicos }}</v-list-item-title>
                    <v-list-item-subtitle>Ingressos Físicos</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      
      <!-- Composição do Evento (se houver) -->
      <v-row v-if="quantidadeComposicao.length > 0" class="mt-6">
        <v-col cols="12">
          <v-card class="rounded-lg" elevation="2">
            <v-card-title class="text-subtitle-1 font-weight-bold">
              <v-icon left color="primary">mdi-format-list-checks</v-icon>
              Composição do Evento
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" md="3" v-for="item in quantidadeComposicao" :key="item.tipo">
                  <v-card outlined class="rounded-lg">
                    <v-card-text class="text-center">
                      <p class="text-h5 font-weight-bold mb-1">{{ item.quantidade }}</p>
                      <p class="text-subtitle-2 grey--text text--darken-1 mb-0">{{ item.tipo }}</p>
                    </v-card-text>
                  </v-card>
        </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Botões de Ação -->
      <v-speed-dial
        v-model="fab"
        fixed
        bottom
        right
        direction="left"
        transition="slide-y-reverse-transition"
      >
        <template v-slot:activator>
          <v-btn v-model="fab" color="primary" dark fab>
            <v-icon v-if="fab">mdi-close</v-icon>
            <v-icon v-else>mdi-swap-vertical</v-icon>
          </v-btn>
        </template>

        <v-btn fab dark color="success" @click="openDialog('CHECKIN')">
          <v-icon>mdi-arrow-down-circle</v-icon>
        </v-btn>

        <v-btn fab dark color="error" @click="openDialog('CHECKOUT')">
          <v-icon>mdi-arrow-up-circle</v-icon>
        </v-btn>

        <v-btn fab dark color="info" @click="dialogoTotemCheckin = true">
          <v-icon>mdi-monitor-dashboard</v-icon>
        </v-btn>
      </v-speed-dial>

      <v-row>
        <v-dialog v-model="dialog" max-width="350px">
          <v-card style="border-radius: 10px">
            <v-card-title class="d-flex justify-center pt-5 pb-0">
              <span class="text-h6 font-weight-medium purple--text text--darken-2">{{ acao }}</span>
            </v-card-title>
            <v-card-text v-if="!validacao" style="text-align: center; padding: 0px 5px 0px">
              <v-container>
                <v-row align="center" justify="center" v-if="acao == 'CHECKOUT'">
                  <v-col cols="12" sm="6" md="12">
                    <p class="texto" :style="`color:${corValidacao}`">
                      {{ evento }}
                    </p>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center" v-if="acao == 'CHECKIN'">
                  <v-col cols="12" sm="6" md="12">
                    <v-radio-group v-model="tipo" row hide-details>
                      <v-radio color="#7B1FA2" label="QRCODE" value="1"></v-radio>
                      <v-radio color="#7B1FA2" label="CÓDIGO" value="2"></v-radio>
                      <v-radio color="#7B1FA2" label="CPF" value="3"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" v-if="tipo == '1'">
                    <qrcode-stream @decode="onDecode"></qrcode-stream>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" v-if="tipo == '2'">
                    <v-text-field light label="CÓDIGO" color="#7B1FA2" type="tel" outlined hide-details dense
                      v-model="codigo"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" v-if="tipo == '3'">
                    <v-text-field light label="CPF" color="#7B1FA2" outlined v-mask="'###.###.###-##'" dense
                      hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')"
                      data-vv-name="cpf" type="tel" v-model="cpf"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-text v-if="validacao" style="text-align: center; padding: 0px 5px 0px">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="12" md="12">
                    <v-card class="elevation-0 rounded-lg pa-4 pb-0" color="transparent">
                      <div class="d-flex flex-column align-center">
                        <!-- Ícone com animação de fade apenas para mensagens que NÃO sejam de sucesso e NÃO sejam de validação anterior -->
                        <v-fade-transition>
                          <div class="text-center mb-3" 
                               v-if="!(msgValidacao === 'Validação efetuada com sucesso' && corValidacao === '#43A047') && 
                                     !msgValidacao.includes('Validação já efetuada anteriormente')">
                            <v-avatar
                              size="80"
                              :color="corValidacao + '16'" 
                              class="elevation-0"
                            >
                              <v-icon :color="corValidacao" size="40">{{ iconValidacao }}</v-icon>
                            </v-avatar>
                          </div>
                        </v-fade-transition>
                        
                        <!-- Título da validação -->
                        <div v-if="msgValidacao === 'Validação efetuada com sucesso' && corValidacao === '#43A047'" class="text-center">
                          <!-- Destaque melhor para o status de sucesso -->
                          <div class="success-highlight mb-4 py-3 px-5" style="background-color: rgba(67, 160, 71, 0.1); border-radius: 16px;">
                            <v-avatar 
                              color="#43A047" 
                              size="80" 
                              class="mb-3 elevation-1"
                            >
                              <v-icon color="white" size="40">check</v-icon>
                            </v-avatar>
                            <h2 class="text-h4 font-weight-bold mb-1" style="color: #2E7D32">SUCESSO</h2>
                            <p class="text-subtitle-1" style="color: #43A047">Validação efetuada com sucesso</p>
                          </div>
                        </div>
                        <div v-else-if="msgValidacao.includes('Validação já efetuada anteriormente')" class="text-center">
                          <!-- Destaque para validação anterior com design consistente -->
                          <div class="already-validated-highlight mb-4 py-4 px-4" style="background-color: rgba(255, 152, 0, 0.1); border-radius: 16px; max-width: 100%;">
                            <v-avatar 
                              color="#FF9800" 
                              size="70" 
                              class="mb-3 elevation-1"
                            >
                              <v-icon color="white" size="36">info</v-icon>
                            </v-avatar>
                            <h2 class="text-h5 font-weight-bold mb-2" style="color: #E65100">ATENÇÃO</h2>
                            <!-- Exibir a mensagem formatada sem duplicação -->
                            <p class="text-subtitle-1 font-weight-medium mb-2" style="color: #FF9800; word-break: break-word; line-height: 1.4;">
                              {{ 
                                msgValidacao.includes(':') 
                                  ? 'Validação já efetuada anteriormente:'
                                  : msgValidacao 
                              }}
                            </p>
                            <p v-if="msgValidacao.includes(':')" class="text-subtitle-2 font-weight-medium" style="color: #E65100; word-break: break-word; line-height: 1.4;">
                              {{ msgValidacao.substring(msgValidacao.indexOf(':') + 1).trim() }}
                            </p>
                          </div>
                        </div>
                        <div v-else class="text-center">
                          <p class="text-subtitle-1 font-weight-bold" :style="`color:${corValidacao}`">{{ msgValidacao }}</p>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  
                  <v-col cols="12" sm="6" md="12" style="padding: 2px" v-if="participantes > 1">
                    <v-card flat :color="corValidacao" dark>
                      <v-card-text class="text-center">
                        <span style="font-size: 18px; font-weight: bold;">{{ participantes }} participantes</span>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" v-if="inscricaoAtual && inscricaoAtual.id">
                    <v-card flat outlined>
                      <v-card-title class="subtitle-1 font-weight-bold">Detalhes da Inscrição</v-card-title>
                      <v-card-text>
                        <v-row>
                          <!-- Informações básicas apenas quando não tem vagas -->
                          <v-col cols="12" v-if="!inscricaoAtual.vagas || inscricaoAtual.vagas.length === 0">
                            <div class="mb-2">
                              <p class="mb-0 font-weight-bold text-h6">{{ inscricaoAtual.nome || 'Não informado' }}</p>
                              <p class="mb-0 caption" v-if="inscricaoAtual.cpf">CPF: {{ inscricaoAtual.cpf }}</p>
                            </div>
                          </v-col>

                          <v-col cols="12" v-if="inscricaoAtual.vagas && inscricaoAtual.vagas.length > 0">
                            <v-card outlined class="rounded-lg">
                              <v-card-title class="subtitle-2 py-2 d-flex justify-space-between purple lighten-5">
                                <span class="black--text">Participantes</span>
                                <v-chip color="#7B1FA2" text-color="white" small>
                                  <span class="font-weight-bold">{{ inscricaoAtual.vagas.length }}</span>
                                </v-chip>
                              </v-card-title>
                              <v-card-text class="pa-0">
                                <v-list dense class="pa-0">
                                  <!-- Titular (primeira vaga) -->
                                  <v-list-item 
                                    v-if="inscricaoAtual.vagas.length > 0"
                                    class="px-3 py-2"
                                    key="titular"
                                    :class="{'purple lighten-5': true}"
                                  >
                                    <v-list-item-content>
                                      <div class="d-flex align-center">
                                        <span class="font-weight-bold black--text">{{ inscricaoAtual.nome || 'Titular' }}</span>
                                        <v-chip x-small color="primary" text-color="white" class="ml-2">Titular</v-chip>
                                      </div>
                                      <v-list-item-subtitle class="mt-1">
                                        Vaga: {{ inscricaoAtual.vagas[0].vaga }} ({{ inscricaoAtual.vagas[0].setor }})
                                        <span v-if="inscricaoAtual.tamanhoCamisa">
                                          | Camisa: {{ inscricaoAtual.tamanhoCamisa }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle v-if="inscricaoAtual.cpf" class="mt-1">
                                        CPF: {{ inscricaoAtual.cpf }}
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                  
                                  <!-- Divisor entre titular e acompanhantes quando houver -->
                                  <v-divider v-if="inscricaoAtual.vagas && inscricaoAtual.vagas.length > 1"></v-divider>
                                  
                                  <!-- Acompanhantes -->
                                  <v-list-item 
                                    v-for="(vaga, index) in inscricaoAtual.vagas.slice(1)"
                                    :key="'vaga-'+index" 
                                    class="px-3 py-2"
                                    :class="{'grey lighten-4': index % 2 === 0}"
                                  >
                                    <v-list-item-content>
                                      <div class="black--text">
                                        <span v-if="getAcompanhanteInfo(vaga.vaga, inscricaoAtual.detalhes).nome">
                                          {{ getAcompanhanteInfo(vaga.vaga, inscricaoAtual.detalhes).nome }}
                                        </span>
                                        <span v-else>Acompanhante {{ index + 1 }}</span>
                                      </div>
                                      <v-list-item-subtitle class="mt-1">
                                        Vaga: {{ vaga.vaga }} ({{ vaga.setor }})
                                        <span v-if="getAcompanhanteInfo(vaga.vaga, inscricaoAtual.detalhes).camisa">
                                          | Camisa: {{ getAcompanhanteInfo(vaga.vaga, inscricaoAtual.detalhes).camisa }}
                                        </span>
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px" v-if="composicao">
                    <p class="texto" :style="`color:${corValidacao}; font-size: 17px`">
                      <b>{{ formatarSetor(composicao) }}</b>
                    </p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions v-if="!validacao" style="margin-top: -32px; padding: 20px 5px 0px">
              <v-container fluid grid-list-md>
                <v-layout row wrap justify-center>
                  <v-flex xs6 sm6 lg6 v-if="tipo != 1">
                    <v-btn :loading="loading" dark depressed block color="#4A148C" style="border-radius: 7px" large
                      @click="validarInscricao">Validar</v-btn>
                  </v-flex>
                  <v-flex xs6 sm6 lg6>
                    <v-btn dark depressed block color="#D32F2F" style="border-radius: 7px" large
                      @click="close">Fechar</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-actions>
            <v-card-actions v-if="validacao" style="padding: 16px 16px 24px 16px">
              <v-container fluid>
                <v-row justify="center">
                  <v-col cols="12" sm="8" md="6">
                    <v-btn 
                      rounded 
                      elevation="1" 
                      block 
                      color="#4A148C" 
                      class="white--text font-weight-medium text-capitalize px-6"
                      @click="closeResultado"
                    >
                      <v-icon left>check</v-icon>
                      Finalizar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog persistent v-model="dialogoInscricoesLocalizadas" max-width="900px">
          <v-card>
            <v-card-title>Inscrições</v-card-title>
            <v-card-text style="padding-bottom: 0px">
              <v-data-table :headers="tabela.cabecalho" :items="tabela.conteudo" :items-per-page="tabela.itensPorPagina"
                hide-default-footer>
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn text outlined color="success" @click="doCheckin(item)">
                    <v-icon left>check_circle</v-icon>Check-in
                  </v-btn>
                </template>
                <template v-slot:[`item.checkin`]="{ item }">
                  <p v-if="item.checkin" style="font-size: 10px; margin: 0px">
                    Check-in efetuado em
                    {{ transformaData(item.checkin, "DD/MM/YYYY") }} às
                    {{ transformaData(item.checkin, "HH:mm:ss") }} por
                    {{ item.userValidatorCheckinId }}.
                  </p>
                  <p>NÃO EFETUADO</p>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogoInscricoesLocalizadas = false" color="error">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoTotemCheckin" max-width="600px" scrollable persistent fullscreen>
          <div class="container-login">
            <v-container fluid>
              <v-row align="center" justify="center">
                <v-col cols="12" sm="12" md="8" lg="8">
                  <v-card class="login" flat style="border-radius: 10px; padding: 0px">
                    <span class="login-title">
                      <img :src="companyobj.logoUrl" width="200px" />
                    </span>
                    <v-card-text style="padding: 0px">
                      <v-container fluid grid-list-md>
                        <v-layout row wrap justify-center>
                          <!-- CADASTRO -->
                          <v-col cols="12" sm="12" md="8" lg="8">
                            <v-card dark style="background: #0088e2">
                              <div>
                                <div>
                                  <v-card-title class="text-h6">
                                    <v-btn block large @click="abreCheckinTotem('1')" depressed color="#0088e2">
                                      <v-icon left>mdi-qrcode</v-icon>Check-in
                                      por QRCode
                                    </v-btn>
                                  </v-card-title>
                                </div>
                              </div>
                            </v-card>
                          </v-col>
                          <!--  -->
                          <v-col cols="12" sm="12" md="8" lg="8">
                            <v-card dark style="background: #0088e2">
                              <div>
                                <div>
                                  <v-card-title class="text-h6">
                                    <v-btn block large @click="abreCheckinTotem('2')" depressed color="#0088e2">
                                      <v-icon left>mdi-card-account-details</v-icon>Check-in por CPF
                                    </v-btn>
                                  </v-card-title>
                                </div>
                              </div>
                            </v-card>
                          </v-col>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <br />
            </v-container>
          </div>
        </v-dialog>

        <v-dialog v-model="dialogoCaptura" max-width="600px" scrollable persistent>
          <v-card>
            <v-card-title>{{
              mensagemCheckin ? mensagemCheckin : "Check-in"
            }}</v-card-title>
            <v-card-text style="text-align: center; padding-bottom: 0px" v-if="!validacao">
              <v-row align="center" justify="center">
                <v-col cols="12" style="text-align: center" v-if="tipo == '1'">
                  <v-icon size="100">mdi-qrcode-scan</v-icon>
                  <p style="margin: 10px 0px 0px 0px; font-size: 17px">
                    Aproxime o QR Code do seu cartão de consumo ao leitor
                  </p>
                </v-col>
                <v-col cols="12" v-if="tipo == '1'" style="position: absolute; left: -99999px">
                  <v-text-field v-model="codigoQrCode" id="campoCaptura" @keydown.enter="checkinTotem(codigoQrCode)"
                    @blur="focaCampo"></v-text-field>
                </v-col>
                <v-col cols="12" v-if="tipo == '2'">
                  <v-text-field id="campoCpf" label="CPF" color="#7B1FA2" outlined v-mask="'###.###.###-##'"
                    hide-details required type="tel" v-model="cpf"></v-text-field>
                  <v-btn :loading="loading" depressed block color="#4A148C" :dark="cpf.length == 14"
                    @click="checkinTotem(null, cpf)" :disabled="cpf.length != 14"
                    style="margin-top: 10px">Validar</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <!-- tela que exibe a validação do check-in -->
            <v-card-text v-else>
              <v-container v-if="exibeEtiqueta" style="padding: 3px; border: 1px #ddd solid; border-radius: 5px">
                <v-row dense style="padding: 0px 20px 0px 20px">
                  <v-col cols="9">
                    <p style="margin: 0px; font-size: 30px; font-weight: bold">{{ impressao.nome }}</p>
                  </v-col>
                  <v-col cols="3" style="text-align: right">
                    <p style="margin: 0px; font-size: 30px; font-weight: bold">{{ impressao.idade }}</p>
                  </v-col>
                  <v-col cols="12" style="padding: 0px">
                    <p style="margin: 0px; font-size: 20px">{{ impressao.sobrenome }}</p>
                  </v-col>
                  <v-col cols="6" style="text-align: center">
                    <p style="margin: 0px; font-size: 14px">{{ impressao.nomePai }}</p>
                    <p style="margin: 0px; font-size: 14px">{{ impressao.telefonePai }}</p>
                  </v-col>
                  <v-col cols="6" style="text-align: center">
                    <p style="margin: 0px; font-size: 14px">{{ impressao.nomeMae }}</p>
                    <p style="margin: 0px; font-size: 14px">{{ impressao.telefoneMae }}</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="#D32F2F" v-if="!validacao" @click="dialogoCaptura = false">Fechar</v-btn>
              <v-btn text color="#D32F2F" v-if="validacao" @click="fecharValidacao">Fechar</v-btn>
              <!-- <v-btn text color="#00695C" @click="imprimir" v-if="exibeEtiqueta && mensagemCheckin.includes('já efetuada anteriormente') || mensagemCheckin.includes('efetuada com sucesso')">Imprimir etiqueta</v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoExibeVagas" persistent max-width="800px" scrollable>
          <v-card>
            <v-toolbar color="#474d55" dark dense>
              <v-toolbar-title>Check-in de vagas</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="dialogoExibeVagas = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text style="padding: 0px">
              <v-data-table v-model="vagasSelecionadas" :headers="tabelaVagas.cabecalho" :items="tabelaVagas.conteudo"
                :search="tabelaVagas.busca" :single-select="false" item-key="vaga" show-select :footer-props="{
                  'items-per-page-text': 'Linhas por página',
                  'items-per-page-all-text': 'Tudo',
                }">
                <template v-slot:[`header.data-table-select`]="{ }"></template>

                <template v-slot:[`item.vagas.checkin`]="{ item }">
                  <td v-if="item.vagas.checkin">Realizado em {{ formatDateBrz(item.checkin.substring(0, 10)) }} às {{
                    item.checkin.substring(11, 19) }}</td>
                  <td v-else style="color: #666">Ainda não realizado</td>
                </template>

                <template v-slot:[`item.data-table-select`]="{ item, select }">
                  <v-checkbox hide-details style="margin: 0px; padding: 0px" :disabled="Boolean(item.checkin)"
                    :value="vagasSelecionadas.includes(item)" @click.stop="select(item)"
                    @change="verificaItensSelecionados($event, item)" />
                </template>
              </v-data-table>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" :disabled="vagasSelecionadas.length == 0"
                @click="checkinVagas">Continuar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoCheckinMesas" max-width="350px">
          <v-card>
            <v-card-text style="text-align: center; padding: 0px 5px 0px">
              <v-container>
                <br />
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <v-icon large :color="corValidacao" style="font-size: 100px">{{ iconValidacao }}</v-icon>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" :style="`color:${corValidacao}; font-size: 17px`">
                      <b>{{ msgValidacao }}</b>
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px" v-if="detalhes">
                    <v-card flat outlined>
                      <v-card-title class="subtitle-1 font-weight-bold">Detalhes das Vagas</v-card-title>
                      <v-card-text>
                        <div v-for="(item, index) in detalhes" :key="index">
                          <p class="mb-0" style="font-size: 15px">{{ item }}</p>
                          <v-divider v-if="index < detalhes.length-1" class="my-1"></v-divider>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" v-if="inscricaoAtual && inscricaoAtual.nome">
                    <v-card flat outlined class="mt-2">
                      <v-card-title class="subtitle-1 font-weight-bold">Informações do Participante</v-card-title>
                      <v-card-text>
                        <p class="mb-0"><b>Nome:</b> {{ inscricaoAtual.nome }}</p>
                        <p class="mb-0" v-if="inscricaoAtual.cpf"><b>CPF:</b> {{ inscricaoAtual.cpf }}</p>
                        <p class="mb-0" v-if="inscricaoAtual.email"><b>Email:</b> {{ inscricaoAtual.email }}</p>
                        <p class="mb-0" v-if="inscricaoAtual.telefone"><b>Telefone:</b> {{ inscricaoAtual.telefone }}</p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px" v-if="composicao">
                    <p class="texto" :style="`color:${corValidacao}; font-size: 17px`">
                      <b>{{ formatarSetor(composicao) }}</b>
                    </p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="red" @click="dialogoCheckinMesas = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- <v-col cols="12" sm="12" md="12">
            <v-alert
            :icon="iconMsg"
            prominent
            text
            :color="corMsg"
          >
          <span style="font-weight: bold;">{{msgPontuacao}}</span> {{descPontuacao}}
          </v-alert>
          </v-col> -->
        <!-- <v-col cols="12" sm="12" md="6">
          <v-card style="border-radius: 10px;padding: 10px;">
            <v-card-title style="justify-content: center;">Pesquisas realizadas nos últimos {{diasSelc}} dias</v-card-title>
            <graph-bar
                :width="600"
                :height="300"
                :align="'center'"
                textAlign="center"
                :axis-min="0"
                showTex
                :colors="colors"
                :axis-max="100"
                :labels="datasGrap"
                :axisFormat="true"
                :values="pontuacaoTotal">
                <tooltip :names="names" :position="'center'"></tooltip>
                <legends :names="names" :filter="true"></legends>
            </graph-bar>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="6">
          <v-card style="border-radius: 10px;padding: 10px;">
            <v-card-title style="justify-content: center;">Evolução do NPS nos últimos {{diasSelc}} dias</v-card-title>
            <graph-line
                :width="600"
                :height="300"
                :align="'center'"
                textAlign="center"
                :shape="'normal'"
                :axis-min="-100"
                :axis-max="100"
                :display="'all'"
                :colors="colorLine"
                :axis-full-mode="true"
                :labels="datasGrap"
                names="Pontuação NPS"
                :values="pontuacaoDia">
                <tooltip :names="namesLine" :position="'center'"></tooltip>
                <legends :names="namesLine"></legends>
                <guideline :tooltip-y="true"></guideline>
            </graph-line>
          </v-card>
        </v-col> -->
      </v-row>
    </v-flex>

    <!-- IMPRESSÃO -->
    <v-container id="printEtiqueta" style="padding: 0px" v-show="impressao.nome && impressao.idade">
      <v-row id="printInscricao" dense style="padding: 0px 20px 0px 20px">
        <v-col cols="9">
          <p style="margin: 0px; font-size: 30px; font-weight: bold">{{ impressao.nome }}</p>
        </v-col>
        <v-col cols="3" style="text-align: right">
          <p style="margin: 0px; font-size: 30px; font-weight: bold">{{ impressao.idade }}</p>
        </v-col>
        <v-col cols="12" style="padding: 0px">
          <p style="margin: 0px; font-size: 20px">{{ impressao.sobrenome }}</p>
        </v-col>
        <v-col cols="6" style="text-align: center">
          <p style="margin: 0px; font-size: 14px">{{ impressao.nomePai }}</p>
          <p style="margin: 0px; font-size: 14px">{{ impressao.telefonePai }}</p>
        </v-col>
        <v-col cols="6" style="text-align: center">
          <p style="margin: 0px; font-size: 14px">{{ impressao.nomeMae }}</p>
          <p style="margin: 0px; font-size: 14px">{{ impressao.telefoneMae }}</p>
        </v-col>
      </v-row>
    </v-container>
    <!-- FIM DA IMPRESSÃO -->

    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      timeout="3000"
      top
      right
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog
      v-model="confirmDialog"
      max-width="400"
    >
      <v-card class="rounded-lg">
        <v-card-title class="text-h6">
          {{ confirmTitle }}
        </v-card-title>
        <v-card-text>
          {{ confirmText }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="grey"
            @click="confirmDialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="confirmAction"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref="chamaSnackbar" />
  </v-container>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import { baseApiUrl } from "@/global";
import axios from "axios";
import { mapState } from "vuex";
import moment from "moment";
import Snackbar from "../componentes/snackbar.vue";
import PH from "print-html-element";
// import QrcodeVue from "qrcode.vue";
import CpfValidate from "../componentes/validators/rules/cpf";
export default {
  components: {
    Snackbar,
    Loading,
    // QrcodeVue,
  },
  data() {
    return {
      diasSelc: 7,
      corSelec: "#388E3C",
      fab: false,
      fullPage: true,
      isLoading: false,
      carregandoDados: false,
      eventoId: "",
      eventos: [],
      capacidade: 0,
      inscritos: 0,
      inscritosPagos: 0,
      checkinsRealizados: 0,
      checkinsRealizadosTotal: 0,
      reservados: 0,
      confirmados: 0,
      percentCapac: 0,
      percenteReserv: 0,
      percentInscri: 0,
      percentConfirm: 0,
      percentCheckinTotal: 0,
      percentCheckinUser: 0,
      percentualApoio: 0,
      percentualBasico: 0,
      percentualGrandesEventos: 0,
      percentualAtivo: 0,
      percentualEmAnalise: 0,
      // Valores e pagamentos
      valorTotal: 0,
      valorPago: 0,
      valorPendente: 0,
      percentValorPago: 0,
      percentValorPendente: 0,
      formasPagamento: [],
      dialog: false,
      codigo: "",
      cpf: "",
      tipo: "1",
      acao: "",
      eventoSelecionado: [],
      validacao: false,
      loading: false,
      msgValidacao: "",
      composicao: [],
      iconValidacao: "",
      corValidacao: "",
      contador: "",
      checkin: {
        cod_incricao: "",
        tipo: "",
        eventoId: "",
        empresaId: "",
        userValidatorId: "",
      },
      defaultCheckin: {
        cod_incricao: "",
        tipo: "",
        eventoId: "",
        empresaId: "",
        userValidatorId: "",
      },
      audio: "",
      usaQrcode: false,
      qtdVigilantes: 0,
      qtdApoio: 0,
      qtdBasico: 0,
      qtdGrandesEventos: 0,
      qtdEmAnalise: 0,
      qtdAtivos: 0,
      participantes: 0,
      detalhes: "",
      corValidacaoParticipantes: "#FFFFFF",
      inscricoesLocalizadas: [],
      dialogoInscricoesLocalizadas: false,
      qtdIngressosFisicos: 0,
      qtdIngressosFisicosCortesia: 0,
      tabela: {
        cabecalho: [
          { text: "Nome", align: "start", value: "nome" },
          { text: "Evento", value: "nomeEvento" },
          { text: "Check-in", value: "checkin" },
          { text: "Ações", value: "action", align: "center", sortable: false },
        ],
        conteudo: [],
        itensPorPagina: -1,
      },
      tabelaVagas: {
        cabecalho: [
          { text: "Nome", align: "start", value: "nome" },
          { text: "Vaga", value: "vaga" },
          { text: "Mesa", value: "mesa" },
          { text: "Tamanho Camisa", value: "camisa" },
          { text: "Check-in", value: "checkin" },
          { text: "Ações", value: "action", align: "center", sortable: false },
        ],
        conteudo: [],
        itensPorPagina: -1,
      },
      dialogoTotemCheckin: false,
      exibeEtiqueta: false,
      mensagemCheckin: "",
      impressao: {
        nome: '',
        sobrenome: '',
        idade: '',
        nomePai: '',
        telefonePai: '',
        nomeMae: '',
        telefoneMae: '',

        nomeCracha: '',
        empresa: '',
      },
      codigoQrCode: "",
      dialogoCaptura: false,
      vagasSelecionadas: [],
      dialogoExibeVagas: false,
      dialogoCheckinMesas: false,
      eventoCheckin: '',
      quantidadeComposicao: [],
      listaVagas: [],
      inscricaoAtual: {},
      fabVigilante: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      confirmDialog: false,
      confirmTitle: '',
      confirmText: '',
      confirmCallback: null,
      darkMode: false,
      searchEvent: '',
      ocultarValores: false,
      periodoFiltro: 'todos',
      opcoesPeriodo: [
        { texto: 'Todos os períodos', valor: 'todos' },
        { texto: 'Hoje', valor: 'hoje' },
        { texto: 'Esta semana', valor: 'semana' },
        { texto: 'Este mês', valor: 'mes' },
        { texto: 'Personalizado', valor: 'personalizado' },
      ],
      datasFiltro: [],
      menuData: false,
      exibirPeriodoPersonalizado: 'Selecione as datas',
      dataInicioFiltro: null,
      dataFimFiltro: null,
      menuFiltro: false,
    };
  },
  computed: {
    ...mapState({
      usuarioadmin: (state) => state.Userpermission,
      usuarioLogado: (state) => state.isMenuVisible,
      user: (state) => state.userObj,
      companyobj: (state) => state.companyObj,
    }),
    itensOrdenados() {
      return this.eventos.slice().sort((a, b) => {
        // Se ambos não têm 'ordenacao', mantêm a ordem
        if (a.ordenacao == null && b.ordenacao == null) {
          return 0;
        }

        // Se 'a' não tem 'ordenacao', joga ele para o fim
        if (a.ordenacao == null) {
          return 1;
        }

        // Se 'b' não tem 'ordenacao', joga ele para o fim
        if (b.ordenacao == null) {
          return -1;
        }

        // Se ambos têm 'ordenacao', ordena normalmente
        return a.ordenacao - b.ordenacao;
      });
    },
    formasPagamentoValidas() {
      return this.formasPagamento.filter(forma => forma.valor > 0);
    },
    periodoAtivo() {
      if (this.periodoFiltro === 'todos' || (!this.dataInicioFiltro && !this.dataFimFiltro)) {
        return null;
      }
      
      switch(this.periodoFiltro) {
        case 'hoje':
          return 'Inscrições de hoje';
        case 'semana':
          return 'Inscrições desta semana';
        case 'mes':
          return 'Inscrições deste mês';
        case 'personalizado':
          if (this.datasFiltro.length === 2) {
            return `Inscrições de ${this.exibirPeriodoPersonalizado}`;
          }
          return null;
        default:
          return null;
      }
    }
  },
  mounted() {
    this.carregaDados();
    this.inscricoesVigilantes();
    this.loadThemePreference();
    this.audio = new Audio(require("../assets/beep.mp3"));
    this.$validator && this.$validator.localize("pt", this.dictionary);
  },
  created() {
    this.init();
  },
  watch: {
    tipo(val) {
      if (val === "1") {
        this.cpf = "";
        this.$validator.reset();
      } else if (val === "2") this.codigo = "";
    },

    validacao() {
      this.cpf = "";
      this.codigo = "";
      this.checkin = Object.assign({}, this.defaultCheckin);
    },

    dialogoCaptura(val) {
      if (val == false) {
        this.dialogoCaptura = false;
        this.tipo = 0;
        this.codigoQrCode = "";
      } else {
        this.focaCampo();
      }
    },

    exibeEtiqueta(val) {
      if (val == true) {
        setTimeout(() => {
          this.imprimir();
        }, 1000);
      }
    },
  },

  methods: {
    init() {
      this.companyobj = JSON.parse(sessionStorage.getItem("companyobj"));
      this.user = JSON.parse(sessionStorage.getItem("usuario"));
    },
    loadThemePreference() {
      // Carregar preferência do modo escuro do localStorage
      const savedDarkMode = localStorage.getItem('darkMode');
      if (savedDarkMode !== null) {
        this.darkMode = savedDarkMode === 'true';
        this.$vuetify.theme.dark = this.darkMode;
        
        if (this.darkMode) {
          document.documentElement.classList.add('dark-mode');
        } else {
          document.documentElement.classList.remove('dark-mode');
        }
      } else {
        // Verificar preferência do sistema operacional
        const prefersDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
        if (prefersDarkMode) {
          this.darkMode = true;
          this.$vuetify.theme.dark = true;
          document.documentElement.classList.add('dark-mode');
          localStorage.setItem('darkMode', 'true');
        }
      }
    },
    async onDecode(decodedString) {
      this.codigo = decodedString;
      this.usaQrcode = true;

      await axios.get(baseApiUrl + 'inscricoes/findOne?filter={"where":{"cod_incricao":"' + this.codigo + '"}, "include":"evento"}&access_token=' + sessionStorage.getItem("accToken"))
        .then(async response => {
          if (response.data) {
            this.inscricoesLocalizadas = response.data;
            this.inscricaoAtual = response.data; // Armazenar dados da inscrição atual
            this.eventoCheckin = response.data.eventoId;

            if (response.data.evento.tipo == 'MESA') {
              for (let i = 0; i < response.data.vagas.length; i++) {
                for (let j = 0; j < response.data.evento.qtdVagasMesa; j++) {
                  this.listaVagas.push({
                    "mesa": response.data.vagas[i].vaga,
                    "vaga": (j + 1),
                    "checkin": response.data.vagas[i].checkin ? response.data.vagas[i].checkin[j] : '',
                  });
                }
              }

              this.tabelaVagas.conteudo = this.listaVagas;
              this.close();
              this.eventoCheckin = response.data.evento.id;
              this.dialogoExibeVagas = true;

            } else if (response.data.evento.tipo == 'CADEIRA') {

              let listaCamisa = [];
              let detalhes = response.data.detalhes;
              let regex = /\(([^)]+)\)/g;
              let match;

              if (response.data.tamanhoCamisa) {
                listaCamisa.push(response.data.tamanhoCamisa);
              }

              while ((match = regex.exec(detalhes)) !== null) {
                listaCamisa.push(match[1]);
              }

              this.vagasSelecionadas = response.data.vagas.map((vaga, i) => ({
                mesa: vaga.vaga,
                camisa: response.data.tamanhoCamisa,
                vaga: i + 1,
                "checkin": response.data.vagas[i].checkin || ''
              }));

              await this.checkinVagas();
            } else if (response.data.evento.tipo == 'MULTIPLOS') {

              this.listaVagas = [];

              // Adicionar o primeiro participante como o nome da inscrição
              this.listaVagas.push({
                "nome": response.data.vagas[0].nome,
                "vaga": 1,
                "mesa": 1,
                "checkin": response.data.vagas[0] ? response.data.vagas[0].checkin || '' : ''
              });

              // Adicionar os demais participantes
              for (let i = 1; i < response.data.participantes; i++) {
                this.listaVagas.push({
                  "nome": response.data.vagas[i].nome,
                  "vaga": i + 1,
                  "mesa": i + 1,
                  "checkin": response.data.vagas[i] ? response.data.vagas[i].checkin || '' : ''
                });
              }

              this.tabelaVagas.conteudo = this.listaVagas;
              this.close();
              this.eventoCheckin = response.data.evento.id;
              this.dialogoExibeVagas = true;
            } else {
              await axios.post(baseApiUrl + "inscricoes/preCheckin?access_token=" + sessionStorage.getItem("accToken"), { cod_incricao: this.codigo })
                .then((response) => {
                  if (response.data) {
                    if (response.data.length == 1) {
                      if (response.data[0].tamanhoCamisa) {
                        this.composicao = response.data[0];
                      } else {
                        this.composicao = response.data[0].composicao;
                      }
                      this.confirmaCheckin(response.data[0].eventoId);
                    } else if (response.data.length > 1) {
                      this.tabela.conteudo = response.data;
                      this.dialog = false;
                      this.dialogoInscricoesLocalizadas = true;
                      this.isLoading = false;
                    }
                  }
                })
            }
          }
        })
        .catch(() => {
          // Tratamento de erro silencioso
        });
    },

    verificaItensSelecionados(event, item) {
      if (event) {
        this.vagasSelecionadas.push(item);
      }
      else {
        const index = this.vagasSelecionadas.indexOf(item);
        if (index > -1) {
          this.vagasSelecionadas.splice(index, 1);
        }
      }
    },

    async checkinVagas() {
      var vm = this;
      this.isLoading = true
      let dados = {
        "cod_incricao": this.codigo,
        "tipo": "CHECKIN",
        "eventoId": this.eventoCheckin,
        "userValidatorId": this.user.id,
        "vagas": this.vagasSelecionadas,
      }

      let inscricao = this.inscricoesLocalizadas;
      this.inscricaoAtual = inscricao; // Atualizar a propriedade inscricaoAtual
      
      let nomeInscricao = inscricao.nome.trim();
      let detalhesString = inscricao.detalhes ? inscricao.detalhes.trim() : '';
      let detalhesArray = detalhesString.split(',').map(item => item.trim());
      let detalhesCheckin = [];

      if (inscricao.evento.tipo === 'MULTIPLOS') {
        for (let i = 0; i < dados.vagas.length; i++) {
          detalhesCheckin.push(`${dados.cod_incricao} - ${dados.vagas[i].nome}`);
        }
      } else {
        detalhesCheckin.push(`${inscricao.vagas[0].vaga} - ${nomeInscricao} (${inscricao.tamanhoCamisa})`);
        for (let i = 1; i < inscricao.vagas.length; i++) {
          let nome = detalhesArray[i - 1] ? detalhesArray[i - 1].split(' - ')[1].trim() : 'Nome Desconhecido';
          detalhesCheckin.push(`${inscricao.vagas[i].vaga} - ${nome}`);
        }
      }

      this.detalhesCheckin = detalhesCheckin.join(' | ');
      this.detalhesCheckin = this.detalhesCheckin.split(' | ')

      await axios.post(baseApiUrl + 'inscricoes/checkin?access_token=' + sessionStorage.getItem("accToken"), dados)
        .then(response => {
          if (response.data) {
            switch (response.data.codigo) {
              case 1:
                //'Validação já efetuada anteriormente'
                if (this.usaQrcode) this.audio.play();
                this.msgValidacao = response.data.resposta;
                this.iconValidacao = "error_outline";
                this.corValidacao = "#FF8F00";
                this.dialogoExibeVagas = false
                this.detalhes = this.detalhesCheckin;
                this.dialogoCheckinMesas = true
                this.isLoading = false
                this.vagasSelecionadas = []
                this.eventoCheckinMesas = ''
                break;
              case 2:
                //'Vagas esgotadas para o evento'
                this.msgValidacao = response.data.resposta;
                this.iconValidacao = "cancel";
                this.corValidacao = "#D32F2F";
                this.dialogoExibeVagas = false
                this.dialogoCheckinMesas = true
                this.isLoading = false
                this.vagasSelecionadas = []
                this.eventoCheckinMesas = ''
                break;
              case 3:
                //'Validação efetuada com sucesso'
                if (this.usaQrcode) this.audio.play();
                this.participantes = response.data.participantes;
                this.detalhes = response.data.detalhes;
                this.msgValidacao = response.data.resposta;
                this.iconValidacao = "check_circle_outline";
                this.corValidacao = "#43A047";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                this.composicao = response.data.composicao;
                if (response.data.inscricao) {
                  this.inscricaoAtual = response.data.inscricao;
                }
                break;
              case 5:
                //'Inscrição não localizada pra este evento'
                if (this.usaQrcode) this.audio.play();
                this.detalhes = this.detalhesCheckin;
                this.msgValidacao = response.data.resposta;
                this.iconValidacao = "cancel";
                this.corValidacao = "#D32F2F";
                this.dialogoExibeVagas = false
                this.dialogoCheckinMesas = true
                this.isLoading = false
                this.vagasSelecionadas = []
                this.eventoCheckinMesas = ''
                break;
              case 8:
                //'Inscrição com pagamento pendente'
                if (this.usaQrcode) this.audio.play();
                this.msgValidacao = response.data.resposta;
                this.iconValidacao = "error_outline";
                this.corValidacao = "#FF8F00";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                this.composicao = response.data.composicao;
                if (response.data.inscricao) {
                  this.inscricaoAtual = response.data.inscricao;
                }
                break;
              default:
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                break;
            }
          }
        }).catch(() => {
          this.isLoading = false;
          this.close();
          vm.$refs.chamaSnackbar.snack(
            "#EF5350",
            "Problema ao realizar check-in, tente novamente",
            "DESCULPE"
          );
        });
    },

    async carregaDados() {
      this.isLoading = true;
      await axios
        .get(
          `${baseApiUrl}Eventos?filter={"where":{"and":[{"empresaId":"${this.companyobj.id
          }"}]}}&access_token=${sessionStorage.getItem("accToken")}`
        )
        .then((res) => {
          if (res.data != "") {
            for (var key in res.data) {
              if (res.data.hasOwnProperty(key)) {
                if (
                  moment(
                    this.formatDateHora(res.data[key].fim),
                    "DD/MM/YYYY HH:mm:ss",
                    true
                  ).format() >= moment().format()
                ) {
                  this.eventos.push(res.data[key]);
                }
              }
            }

            this.eventos = this.eventos.sort(this.compare);
            if (this.eventos[0].ordenacao == null) {
              this.eventoId = this.eventos[0].id;
            } else {
              this.eventoId = this.itensOrdenados[0].id;
            }
          } else {
            this.isLoading = false;
          }
        });
      await this.carregaValores();
    },
    formatDateBrz(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    formatDatePadrao(date) {
      if (!date) return null;

      const [day, month, year] = date.substr(0, 10).split("/");
      return `${year}-${month}-${day}` + " " + date.substr(11, 6);
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    formatDateHora(date) {
      if (!date) return null;

      const [year, month, day] = date.substr(0, 10).split("-");
      return `${day}/${month}/${year}` + " " + date.substr(11, 8);
    },
    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const dataA = a.fim;
      const dataB = b.fim;

      let comparison = 0;
      if (dataA > dataB) {
        comparison = 1;
      } else if (dataA < dataB) {
        comparison = -1;
      }
      return comparison;
    },

    openDialog(acao) {
      if (acao == "CHECKIN") {
        this.tipo = "1";
        this.audio.play();
      } else this.tipo = "0";
      this.codigo = "";
      this.cpf = "";

      this.acao = acao;
      this.dialog = true;
    },

    async validarInscricao() {
      this.checkin = Object.assign({}, this.defaultCheckin);
      this.loading = true;
      if (this.acao == "CHECKIN") {
        this.confirmaCheckin();
      } else if (this.acao == "CHECKOUT") {
        this.confirmaCheckout();
      } else {
        this.loading = false;
      }
    },

    async confirmaCheckin(eventoId) {
      var vm = this;
      if (this.codigo != "") {
        this.checkin.cod_incricao = this.codigo;
        this.checkin.tipo = this.acao;
        this.checkin.eventoId = undefined;
        this.checkin.empresaId = undefined;
        this.checkin.userValidatorId = this.user.id;

        if (this.companyobj.limiteInscricao == "SETOR") {
          this.checkin.empresaId = this.companyobj.id;
        } else {
          this.checkin.eventoId = eventoId ? eventoId : this.eventoId;
        }

        try {
          const res = await axios.post(
            `${baseApiUrl}inscricoes/checkin?access_token=${sessionStorage.getItem(
              "accToken"
            )}`,
            this.checkin
          );
          
          if (res.data != "") {
            switch (res.data.codigo) {
              case 1:
                //'Validação já efetuada anteriormente'
                if (this.usaQrcode) this.audio.play();
                this.participantes = res.data.participantes;
                this.detalhes = res.data.detalhes;
                this.msgValidacao = res.data.resposta;
                this.iconValidacao = "error_outline";
                this.corValidacao = "#FF8F00";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                this.composicao = res.data.composicao;
                if (res.data.inscricao) {
                  this.inscricaoAtual = res.data.inscricao;
                }
                break;
              case 2:
                //'Vagas esgotadas para o evento'
                if (this.usaQrcode) this.audio.play();
                this.msgValidacao = res.data.resposta;
                this.iconValidacao = "cancel";
                this.corValidacao = "#D32F2F";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                break;
              case 3:
                //'Validação efetuada com sucesso'
                if (this.usaQrcode) this.audio.play();
                this.participantes = res.data.participantes;
                this.detalhes = res.data.detalhes;
                this.msgValidacao = res.data.resposta;
                this.iconValidacao = "check_circle_outline";
                this.corValidacao = "#43A047";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                this.composicao = res.data.composicao;
                if (res.data.inscricao) {
                  this.inscricaoAtual = res.data.inscricao;
                }
                break;
              case 4:
                //'Usuário não localizado'
                if (this.usaQrcode) this.audio.play();
                this.msgValidacao = res.data.resposta;
                this.iconValidacao = "error_outline";
                this.corValidacao = "#FF8F00";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                break;
              case 5:
                //'Inscrição não localizada pra este evento'
                if (this.usaQrcode) this.audio.play();
                this.msgValidacao = res.data.resposta;
                this.iconValidacao = "cancel";
                this.corValidacao = "#D32F2F";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                break;
              case 8:
                //'Inscrição com pagamento pendente'
                if (this.usaQrcode) this.audio.play();
                this.msgValidacao = res.data.resposta;
                this.iconValidacao = "error_outline";
                this.corValidacao = "#FF8F00";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                this.composicao = res.data.composicao;
                if (res.data.inscricao) {
                  this.inscricaoAtual = res.data.inscricao;
                }
                break;
              default:
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                break;
            }
          }
        } catch (error) {
          this.isLoading = false;
          this.close();
          vm.$refs.chamaSnackbar.snack(
            "#EF5350",
            "Problema ao realizar check-in, tente novamente",
            "DESCULPE"
          );
        }
      } else if (this.cpf != "") {
        try {
          // Formatar o CPF para remover pontuação
          const cpfLimpo = this.cpf.replace(/\D/g, '');
          
          // Buscar a inscrição pelo CPF
          const res = await axios.get(
            `${baseApiUrl}inscricoes?filter={"where":{"and":[{"or":[{"cpf":"${cpfLimpo}"},{"cpf":"${this.cpf}"}]},{"eventoId":"${this.eventoId}"}]}}&access_token=${sessionStorage.getItem("accToken")}`
          );
          
          if (res.data.length > 0) {
            this.checkin.cod_incricao = res.data[0].cod_incricao;
            
            // Atualizar inscricaoAtual para exibir os detalhes
            this.inscricaoAtual = res.data[0];
          } else {
            this.checkin.cod_incricao = 9999;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "CPF não encontrado para este evento",
              "ATENÇÃO"
            );
            this.loading = false;
            return;
          }
        
          // Configurar os parâmetros para o check-in
          this.checkin.tipo = this.acao;
          this.checkin.eventoId = this.eventoId;
          this.checkin.userValidatorId = this.user.id;
          
          // Fazer o check-in
          const checkInRes = await axios.post(
            `${baseApiUrl}inscricoes/checkin?access_token=${sessionStorage.getItem(
              "accToken"
            )}`,
            this.checkin
          );
          
          if (checkInRes.data != "") {
            switch (checkInRes.data.codigo) {
              case 1:
                //'Validação já efetuada anteriormente'
                if (this.usaQrcode) this.audio.play();
                this.participantes = checkInRes.data.participantes;
                this.detalhes = checkInRes.data.detalhes;
                this.msgValidacao = checkInRes.data.resposta;
                this.iconValidacao = "error_outline";
                this.corValidacao = "#FF8F00";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                this.composicao = checkInRes.data.composicao;
                if (checkInRes.data.inscricao) {
                  this.inscricaoAtual = checkInRes.data.inscricao;
                }
                break;
              case 2:
                //'Vagas esgotadas para o evento'
                if (this.usaQrcode) this.audio.play();
                this.msgValidacao = checkInRes.data.resposta;
                this.iconValidacao = "cancel";
                this.corValidacao = "#D32F2F";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                break;
              case 3:
                //'Validação efetuada com sucesso'
                if (this.usaQrcode) this.audio.play();
                this.participantes = checkInRes.data.participantes;
                this.detalhes = checkInRes.data.detalhes;
                this.msgValidacao = checkInRes.data.resposta;
                this.iconValidacao = "check_circle_outline";
                this.corValidacao = "#43A047";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                this.composicao = checkInRes.data.composicao;
                if (checkInRes.data.inscricao) {
                  this.inscricaoAtual = checkInRes.data.inscricao;
                }
                break;
              case 4:
                //'Usuário não localizado'
                if (this.usaQrcode) this.audio.play();
                this.msgValidacao = checkInRes.data.resposta;
                this.iconValidacao = "error_outline";
                this.corValidacao = "#FF8F00";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                break;
              case 5:
                //'Inscrição não localizada pra este evento'
                if (this.usaQrcode) this.audio.play();
                this.msgValidacao = checkInRes.data.resposta;
                this.iconValidacao = "cancel";
                this.corValidacao = "#D32F2F";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                break;
              case 8:
                //'Inscrição com pagamento pendente'
                if (this.usaQrcode) this.audio.play();
                this.msgValidacao = checkInRes.data.resposta;
                this.iconValidacao = "error_outline";
                this.corValidacao = "#FF8F00";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                this.composicao = checkInRes.data.composicao;
                if (checkInRes.data.inscricao) {
                  this.inscricaoAtual = checkInRes.data.inscricao;
                }
                break;
              default:
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                break;
            }
          }
        } catch (error) {
          this.loading = false;
          vm.$refs.chamaSnackbar.snack(
            "#EF5350",
            "Problema ao realizar check-in, tente novamente",
            "DESCULPE"
          );
        }
      } else {
        this.loading = false;
      }
    },

    async confirmaCheckout() {
      this.checkin.cod_incricao = this.codigo;
      this.checkin.tipo = this.acao;
      this.checkin.eventoId = this.eventoId;
      await axios
        .post(
          `${baseApiUrl}inscricoes/checkin?access_token=${sessionStorage.getItem(
            "accToken"
          )}`,
          this.checkin
        )
        .then((res) => {
          if (res.data != "") {
            switch (res.data.codigo) {
              case 7:
                //'Checkout confirmado
                this.msgValidacao = res.data.resposta;
                this.iconValidacao = "check_circle_outline";
                this.corValidacao = "#43A047";
                this.validacao = true;
                this.loading = false;
                // Armazenar o objeto inscricao para exibição dos detalhes
                if (res.data.inscricao) {
                  this.inscricaoAtual = res.data.inscricao;
                }
                break;
              case 6:
                //'O local do evento está vazio'
                this.msgValidacao = res.data.resposta;
                this.iconValidacao = "error_outline";
                this.corValidacao = "#FF8F00";
                this.validacao = true;
                this.loading = false;
                break;
              default:
                break;
            }
            this.checkin.cod_incricao = "";
            this.checkin.tipo = "";
            this.checkin.eventoId = "";
          }
        });
    },

    async carregaValores() {
      this.carregandoDados = true;
      this.quantidadeComposicao = [];
      this.checkinsRealizados = 0; // Inicializar a variável para evitar NaN
      
      let eventoSelecionadoId = typeof this.eventoId === 'object' ? this.eventoId.id : this.eventoId;

      for (var key in this.eventos) {
        if (this.eventos.hasOwnProperty(key)) {
          if (this.eventos[key].id == eventoSelecionadoId) {
            this.capacidade = this.eventos[key].vagas;
            this.reservados = this.eventos[key].reserva || 0; // Garante que seja 0 quando null ou undefined
            this.eventoSelecionado = this.eventos[key];
          }
        }
      }

      // Obter as inscrições para calcular totais
      try {
        // Buscar todas as inscrições do evento
        let res = await axios.get(`${baseApiUrl}inscricoes?filter={"where":{"eventoId":"${eventoSelecionadoId}"}}&access_token=${sessionStorage.getItem("accToken")}`);
        let inscricoes = res.data;
        
        // Aplicar filtro de período nas inscrições, se necessário
        if (this.dataInicioFiltro && this.dataFimFiltro && this.periodoFiltro !== 'todos') {
          const dataInicio = new Date(this.dataInicioFiltro);
          const dataFim = new Date(this.dataFimFiltro);
          
          // Filtrar apenas inscrições pagas no período
          const inscricoesFiltradas = inscricoes.filter(inscricao => {
            if (!inscricao.dataHoraPagamento) return false;
            
            const dataPagamento = new Date(inscricao.dataHoraPagamento);
            return dataPagamento >= dataInicio && dataPagamento <= dataFim;
          });
          
          // Contabilizar inscritos e pagos dentro do período
          this.inscritos = inscricoesFiltradas.length;
          this.inscritosPagos = inscricoesFiltradas.filter(i => i.statusPagamento === 'PAGO').length;
        } else {
          // Usar os dados do dashboard sem filtro
          const resCount = await axios.post(`${baseApiUrl}inscricoes/dashboard?access_token=${sessionStorage.getItem("accToken")}`, { eventoId: eventoSelecionadoId });
          this.inscritos = resCount.data.inscritos ? resCount.data.inscritos : 0;
          this.inscritosPagos = resCount.data.confirmados ? resCount.data.confirmados : 0;
          this.qtdIngressosFisicos = resCount.data.fisicos ? resCount.data.fisicos : 0;
          this.qtdIngressosFisicosCortesia = resCount.data.cortesiaFisica ? resCount.data.cortesiaFisica : 0;
        }

        // Processamento dos check-ins e composição
        this.checkinsRealizadosTotal = 0;
        
        if (this.eventoSelecionado.composicao && this.eventoSelecionado.composicao.length) {
          // Se o filtro de período estiver ativo, usar apenas inscrições filtradas para a composição
          if (this.dataInicioFiltro && this.dataFimFiltro && this.periodoFiltro !== 'todos') {
            const dataInicio = new Date(this.dataInicioFiltro);
            const dataFim = new Date(this.dataFimFiltro);
            
            // Filtrar apenas inscrições pagas no período para a composição
            const inscricoesFiltradas = inscricoes.filter(inscricao => {
              if (!inscricao.dataHoraPagamento) return false;
              
              const dataPagamento = new Date(inscricao.dataHoraPagamento);
              return dataPagamento >= dataInicio && dataPagamento <= dataFim;
            });
            
            this.quantidadeComposicao = this.calculaQuantidadesComposicao(inscricoesFiltradas);
          } else {
            // Sem filtro, usar todas as inscrições
            this.quantidadeComposicao = this.calculaQuantidadesComposicao(inscricoes);
          }
        }

        //this.checkinsRealizados = res.data
        inscricoes.forEach((inscrito) => {
          if (this.eventoSelecionado.tipo == 'MESA') {
            for (let i = 0; i < inscrito.vagas.length; i++) {
              if (inscrito.vagas[i].userValidatorCheckinId && inscrito.vagas[i].userValidatorCheckinId.length > 0) {
                this.checkinsRealizadosTotal += inscrito.vagas[i].userValidatorCheckinId.length
                this.checkinsRealizados += this.carregaQuantidades(inscrito.vagas[i].userValidatorCheckinId)
              }
            }
          } else if (this.eventoSelecionado.tipo == 'MULTIPLOS') {
            for (let i = 0; i < inscrito.vagas.length; i++) {
              if (inscrito.vagas[i].userValidatorCheckinId && inscrito.vagas[i].userValidatorCheckinId.length > 0) {
                this.checkinsRealizadosTotal += inscrito.vagas[i].userValidatorCheckinId.length
                this.checkinsRealizados += this.carregaQuantidades(inscrito.vagas[i].userValidatorCheckinId)
              }
            }
          } else {
            if (inscrito.checkin != null && inscrito.hasOwnProperty("composicao")) {
              for (let f = 0; f < inscrito.composicao.length; f++) {
                // Converte quantidade para número antes de somar
                this.checkinsRealizadosTotal += Number(inscrito.composicao[f].quantidade);
              }
              return;
            }
            if (inscrito.checkin != null && inscrito.userValidatorCheckinId == this.user.id) {
              if (inscrito.hasOwnProperty("participantes") && inscrito.participantes > 0)
                this.checkinsRealizados = this.checkinsRealizados + inscrito.participantes;
              else
                this.checkinsRealizados++;
            }
            if (inscrito.checkin != null) {
              if (inscrito.hasOwnProperty("participantes") && inscrito.participantes > 0)
                this.checkinsRealizadosTotal = this.checkinsRealizadosTotal + inscrito.participantes;
              else
                this.checkinsRealizadosTotal++;
            }
          }
        });
      } catch (error) {
        // Tratamento silencioso do erro
        this.showSnackbar && this.showSnackbar("Erro ao processar dados de check-in", "error");
      } finally {
        this.carregandoDados = false;
      }
      
      // Carregar dados de pagamento
      await this.carregaDadosPagamento();
      
      await this.calculaPercentuais();
      this.recarregaInterface();
    },

    recarregaInterface() {
      this.$forceUpdate(); // Atualiza a interface
    },

    calculaQuantidadesComposicao(listaInscricoes) {
      let contador = {};

      listaInscricoes.forEach(inscricao => {
        if (inscricao.statusPagamento == 'PAGO') {
          inscricao.composicao.forEach(ingresso => {
            let tipo = ingresso.tipo;
            let quantidade = ingresso.quantidade;

            if (contador[tipo]) {
              contador[tipo] += quantidade;
            } else {
              contador[tipo] = quantidade;
            }
          });
        }
      });

      let resultado = Object.keys(contador).map(tipo => {
        return {
          tipo: tipo,
          quantidade: contador[tipo]
        };
      });

      return resultado;
    },

    carregaQuantidades(lista) {
      let contagem = 0

      lista.forEach(item => {
        if (item === this.user.id) {
          contagem++;
        }
      });

      return contagem
    },

    async inscricoesVigilantes() {
      await axios
        .get(
          `${baseApiUrl}Vigilantes/count?access_token=${sessionStorage.getItem(
            "accToken"
          )}`
        )
        .then((res) => {
          this.qtdVigilantes = res.data.count;
        });
      await axios
        .get(
          `${baseApiUrl}Vigilantes/count?where={"qualificacao":"APOIO"}&access_token=${sessionStorage.getItem(
            "accToken"
          )}`
        )
        .then((res) => {
          this.qtdApoio = res.data.count;
        });
      await axios
        .get(
          `${baseApiUrl}Vigilantes/count?where={"qualificacao":"VIGILANTE BÁSICO"}&access_token=${sessionStorage.getItem(
            "accToken"
          )}`
        )
        .then((res) => {
          this.qtdBasico = res.data.count;
        });
      await axios
        .get(
          `${baseApiUrl}Vigilantes/count?where={"qualificacao":"VIGILANTE DE GRANDES EVENTOS"}&access_token=${sessionStorage.getItem(
            "accToken"
          )}`
        )
        .then((res) => {
          this.qtdGrandesEventos = res.data.count;
        });
      await axios
        .get(
          `${baseApiUrl}Vigilantes/count?where={"situacao":"EM ANÁLISE"}&access_token=${sessionStorage.getItem(
            "accToken"
          )}`
        )
        .then((res) => {
          this.qtdEmAnalise = res.data.count;
        });
      await axios
        .get(
          `${baseApiUrl}Vigilantes/count?where={"situacao":"ATIVO"}&access_token=${sessionStorage.getItem(
            "accToken"
          )}`
        )
        .then((res) => {
          this.qtdAtivos = res.data.count;
        });
      await this.calculaPercentuais();
    },

    close() {
      this.tipo = 0;
      this.dialog = false;
      this.corValidacao = "#424f4e";
      setTimeout(() => {
        this.validacao = false;
      }, 300);
    },

    closeResultado() {
      if (this.acao == "CHECKIN") {
        this.tipo = "1";
        this.validacao = false;
        this.corValidacao = "#424f4e";
        this.participantes = 0;
      } else this.close();
      //this.tipo = 1
    },

    async calculaPercentuais() {
      if (this.companyobj.vigilante) {
        this.percentualApoio = (this.qtdApoio * 100) / this.qtdVigilantes;
        this.percentualBasico = (this.qtdBasico * 100) / this.qtdVigilantes;
        this.percentualGrandesEventos =
          (this.qtdGrandesEventos * 100) / this.qtdVigilantes;
        this.percentualAtivo = (this.qtdAtivos * 100) / this.qtdVigilantes;
        this.percentualEmAnalise =
          (this.qtdEmAnalise * 100) / this.qtdVigilantes;
        this.isLoading = false;
      } else {
        this.percenteReserv = (this.reservados * 100) / this.capacidade;
        this.percentInscri = (this.inscritos * 100) / this.capacidade;
        // this.percentConfirm = this.confirmados * 100 / this.capacidade
        this.percentConfirm = (this.inscritosPagos * 100) / this.capacidade;
        this.percentCheckinTotal =
          (this.checkinsRealizadosTotal * 100) / this.inscritosPagos;
        this.percentCheckinUser =
          (this.checkinsRealizados * 100) / this.inscritosPagos;
        this.isLoading = false;
      }
    },

    transformaData(data, formato) {
      let date = moment(data).format(formato);
      return date;
    },

    async doCheckin(item) {
      var vm = this;
      this.isLoading = true;
      this.checkin.cod_incricao = item.cod_incricao;
      this.checkin.tipo = this.acao;
      this.checkin.eventoId = item.eventoId;
      this.checkin.userValidatorId = this.user.id;
      
      // Armazenar dados do participante
      this.inscricaoAtual = item;
      
      await axios
        .post(
          baseApiUrl +
          "inscricoes/checkin?access_token=" +
          sessionStorage.getItem("accToken"),
          this.checkin
        )
        .then((response) => {
          if (response.data) {
            this.dialog = true;
            this.dialogoInscricoesLocalizadas = false;
            switch (response.data.codigo) {
              case 1:
                //'Validação já efetuada anteriormente'
                if (this.usaQrcode) this.audio.play();
                this.participantes = response.data.participantes;
                this.detalhes = response.data.detalhes;
                this.msgValidacao = response.data.resposta;
                this.iconValidacao = "error_outline";
                this.corValidacao = "#FF8F00";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                break;
              case 2:
                //'Vagas esgotadas para o evento'
                if (this.usaQrcode) this.audio.play();
                this.msgValidacao = response.data.resposta;
                this.iconValidacao = "cancel";
                this.corValidacao = "#D32F2F";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                break;
              case 3:
                //'Validação efetuada com sucesso'
                if (this.usaQrcode) this.audio.play();
                this.participantes = response.data.participantes;
                this.detalhes = response.data.detalhes;
                this.msgValidacao = response.data.resposta;
                this.iconValidacao = "check_circle_outline";
                this.corValidacao = "#43A047";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                break;
              case 5:
                //'Inscrição não localizada pra este evento'
                if (this.usaQrcode) this.audio.play();
                this.msgValidacao = response.data.resposta;
                this.iconValidacao = "cancel";
                this.corValidacao = "#D32F2F";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                break;
              case 8:
                //'Inscrição com pagamento pendente'
                if (this.usaQrcode) this.audio.play();
                this.msgValidacao = response.data.resposta;
                this.iconValidacao = "error_outline";
                this.corValidacao = "#FF8F00";
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                break;
              default:
                this.validacao = true;
                this.loading = false;
                this.usaQrcode = false;
                break;
            }
            this.isLoading = false;
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.close();
          vm.$refs.chamaSnackbar.snack(
            "#EF5350",
            "Problema ao realizar check-in, tente novamente",
            "DESCULPE"
          );
        });
    },

    async fazerCheckin(cod_incricao, tipo, eventoId) {
      let resposta;
      let dados = {
        cod_incricao: cod_incricao,
        tipo: tipo,
        eventoId: eventoId,
        userValidatorId: this.user.id,
      };

      try {
        const response = await axios.post(
          baseApiUrl +
          "inscricoes/checkin?access_token=" +
          sessionStorage.getItem("accToken"),
          dados
        );

        if (response.data) {
          resposta = response.data;
          
          // Atualizar inscricaoAtual para exibir os detalhes quando disponíveis
          if (response.data.inscricao) {
            this.inscricaoAtual = response.data.inscricao;
          }
        }
      } catch (error) {
        // Tratar erro silenciosamente
        resposta = {
          codigo: 999,
          resposta: "Erro ao processar check-in. Tente novamente."
        };
      }

      return resposta;
    },
    
    async checkinTotem(codigo, cpf) {
      let url;
      let checkin;
      let vm = this;

      if (codigo) {
        url =
          baseApiUrl +
          'inscricoes?filter={"where":{"and":[{"cod_incricao":"' +
          codigo +
          '"},{"eventoId":"' +
          this.eventoId +
          '"}]}}&access_token=' +
          sessionStorage.getItem("accToken");
      } else {
        if (!CpfValidate(cpf)) {
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "CPF informado é inválido",
            "ATENÇÃO"
          );
          return;
        }

        // Formatação do CPF sem pontos e traços para a consulta
        const cpfLimpo = cpf.replace(/\D/g, '');
        
        url =
          baseApiUrl +
          'inscricoes?filter={"where":{"and":[{"or":[{"cpf":"' +
          cpfLimpo +
          '"},{"cpf":"' +
          cpf +
          '"}]},{"eventoId":"' +
          this.eventoId +
          '"}]}}&access_token=' +
          sessionStorage.getItem("accToken");
      }

      this.isLoading = true;
      
      try {
        const response = await axios.get(url);
        
        if (response.data.length > 0) {
          // Armazenar a inscrição para uso posterior
          this.inscricaoAtual = response.data[0];
          
          checkin = await this.fazerCheckin(
            response.data[0].cod_incricao,
            "CHECKIN",
            this.eventoId
          );

          this.mensagemCheckin = checkin.resposta;

          if (checkin.resposta && (checkin.resposta.includes("já efetuada anteriormente") || checkin.resposta.includes("efetuada com sucesso"))) {
            let nomeCompleto = response.data[0].nome
            let partesDoNome = nomeCompleto.split(" ")

            this.impressao.nome = partesDoNome[0]
            this.impressao.sobrenome = partesDoNome.slice(1).join(" ")
            this.impressao.idade = this.calculateAge(response.data[0].dataNascimento)
            this.impressao.nomePai = response.data[0].nomePai
            this.impressao.telefonePai = response.data[0].telefonePai
            this.impressao.nomeMae = response.data[0].nomeMae
            this.impressao.telefoneMae = response.data[0].telefoneMae
            this.validacao = true;
            this.exibeEtiqueta = true;
          }
        } else {
          this.mensagemCheckin = "Inscrição não localizada para o evento";
          this.validacao = true;
          this.exibeEtiqueta = false;
        }
      } catch (error) {
        this.mensagemCheckin = "Erro ao consultar inscrição. Tente novamente.";
        this.validacao = true;
        this.exibeEtiqueta = false;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Erro ao consultar inscrição. Tente novamente.",
          "DESCULPE"
        );
      } finally {
        this.isLoading = false;
      }
    },

    imprimir() {
      setTimeout(() => {
        PH.printElement(document.getElementById("printEtiqueta"));
      }, 100);
    },

    calculateAge(dataNasc) {
      let dataAtual = new Date();
      let anoAtual = dataAtual.getFullYear();
      let anoNascParts = dataNasc.split("/");
      let diaNasc = anoNascParts[0];
      let mesNasc = anoNascParts[1];
      let anoNasc = anoNascParts[2];
      let idade = anoAtual - anoNasc;
      let mesAtual = dataAtual.getMonth() + 1;
      // Caso mês atual for menor que o de nascimento, não fez aniversário ainda;
      if (mesAtual < mesNasc) {
        idade--;
      } else {
        // Estando no mês do nascimento, verifica o dia
        if (mesAtual == mesNasc) {
          if (new Date().getDate() < diaNasc) {
            // Caso a data atual for menor que o dia de nascimento, ainda não fez aniversário
            idade--;
          }
        }
      }
      return idade;
    },

    validaCpf(cpf) {
      if (!CpfValidate(cpf)) {
        return true;
      } else {
        return false;
      }
    },

    formatarSetor(lista) {
      if (lista) {
        let resultado = "";
        if (lista.tamanhoCamisa) {
          resultado = `Nome: ${lista.nome} - Camisa: ${lista.tamanhoCamisa}`;
        } else {
          lista.forEach((item, index) => {
            if (item.quantidade != "")
              resultado += item.tipo + " (" + item.quantidade + ")";

            if (index !== lista.length - 1 && item.quantidade != "") {
              resultado += " | ";
            }
          });
        }

        return resultado;
      }
    },

    focaCampo() {
      setTimeout(() => {
        if (document.getElementById("campoCaptura")) {
          document.getElementById("campoCaptura").focus();
        }

        if (document.getElementById("campoCpf")) {
          document.getElementById("campoCpf").focus();
        }
      }, 100);
    },

    abreCheckinTotem(tipo) {
      this.tipo = tipo;
      this.dialogoCaptura = true;
    },

    fecharValidacao() {
      this.dialogoCaptura = false;
      this.validacao = false;
      this.mensagemCheckin = "";
      this.exibeEtiqueta = false;
    },

    getAcompanhanteInfo(vagaId, detalhes) {
      if (!detalhes) return { nome: '', camisa: '' };
      
      // Procura no string de detalhes informações sobre a vaga específica
      // Formato esperado: "356 - Prisciane Santos (M), 357 - Ingrid Priscila (M)"
      const detalhesArray = detalhes.split(',').map(item => item.trim());
      
      for (const detalhe of detalhesArray) {
        if (detalhe.startsWith(vagaId.toString())) {
          // Extrai o nome e o tamanho da camisa
          const match = detalhe.match(/(\d+)\s*-\s*([^(]+)\s*\(([^)]+)\)/);
          if (match) {
            return {
              nome: match[2].trim(),
              camisa: match[3].trim()
            };
          }
        }
      }
      
      return { nome: '', camisa: '' };
    },
    
    showSnackbar(text, color = 'success') {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },
    
    confirm(title, text, callback) {
      this.confirmTitle = title;
      this.confirmText = text;
      this.confirmCallback = callback;
      this.confirmDialog = true;
    },
    
    confirmAction() {
      if (this.confirmCallback) {
        this.confirmCallback();
      }
      this.confirmDialog = false;
    },
    
    toggleDarkMode() {
      this.darkMode = !this.darkMode;
      this.$vuetify.theme.dark = this.darkMode;
      
      // Adiciona uma classe temporária para animação
      document.body.classList.add('theme-transition');
      
      // Aplica o modo escuro ao HTML também para controle global
      if (this.darkMode) {
        document.documentElement.classList.add('dark-mode');
        localStorage.setItem('darkMode', 'true');
      } else {
        document.documentElement.classList.remove('dark-mode');
        localStorage.setItem('darkMode', 'false');
      }
      
      // Remove a classe após a transição completar
      setTimeout(() => {
        document.body.classList.remove('theme-transition');
      }, 800);
      
      this.showSnackbar(`Modo ${this.darkMode ? 'escuro' : 'claro'} ativado`, 'info');
    },
    
    refreshData() {
      this.carregaValores();
      this.carregaDadosPagamento();
      this.showSnackbar && this.showSnackbar("Dados atualizados com sucesso", "success");
    },
    isEventActive(event) {
      const now = new Date();
      const start = new Date(event.inicio);
      const end = new Date(event.fim);
      return start <= now && end >= now;
    },
    formatEventDate(event) {
      // Verificar se a data contém 'T' (formato ISO)
      if (event.inicio && event.inicio.includes('T')) {
        return `${event.inicio.split('T')[0].split('-').reverse().join('/')} - ${event.fim.split('T')[0].split('-').reverse().join('/')}`;
      } 
      // Verificar se já está em formato DD/MM/YYYY
      else if (event.inicio && event.inicio.includes('/')) {
        return `${event.inicio.split(' ')[0]} - ${event.fim.split(' ')[0]}`;
      }
      // Fallback para outros formatos
      else {
        return this.formatDateBrz(event.inicio) + ' - ' + this.formatDateBrz(event.fim);
      }
    },
    getEventStatusText(event) {
      if (this.isEventActive(event)) {
        return 'Ativo';
      } else if (new Date(event.inicio) > new Date()) {
        return 'Aberto';
      } else {
        return 'Encerrado';
      }
    },
    getEventStatusColor(event) {
      if (this.isEventActive(event)) {
        return 'success';
      } else if (new Date(event.inicio) > new Date()) {
        return 'info';
      } else {
        return 'error';
      }
    },
    formatarMoeda(valor) {
      // Evitar erros com divisão por zero ou valores indefinidos
      if (!valor || isNaN(valor)) return 'R$ 0,00';
      
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);
    },
    
    getPaymentIcon(tipo) {
      const iconMap = {
        'PIX': 'mdi-contactless-payment',
        'Cartão': 'mdi-credit-card',
        'Boleto': 'mdi-file-document-outline'
      };
      
      return iconMap[tipo] || 'mdi-cash';
    },
    
    getPaymentColor(index) {
      const colors = ['#0CCE6B', '#2962ff', '#f57f17'];
      return colors[index % colors.length];
    },
    
    async carregaDadosPagamento() {
      try {
        // Certifique-se de usar o ID correto do evento
        let eventoSelecionadoId = typeof this.eventoId === 'object' ? this.eventoId.id : this.eventoId;
        
        // Buscar dados de pagamento da API (sem enviar filtro de data para o backend)
        const res = await axios.post(
          `${baseApiUrl}inscricoes/pagamentos?access_token=${sessionStorage.getItem("accToken")}`, 
          { eventoId: eventoSelecionadoId }
        );
        
        if (res.data) {
          // Buscar também as inscrições para poder filtrar por dataHoraPagamento
          const inscricoesRes = await axios.get(
            `${baseApiUrl}inscricoes?filter={"where":{"eventoId":"${eventoSelecionadoId}"}}&access_token=${sessionStorage.getItem("accToken")}`
          );
          
          let inscricoes = inscricoesRes.data || [];
          
          // Aplicar filtro de período nas inscrições
          if (this.dataInicioFiltro && this.dataFimFiltro) {
            const dataInicio = new Date(this.dataInicioFiltro);
            const dataFim = new Date(this.dataFimFiltro);
            
            inscricoes = inscricoes.filter(inscricao => {
              if (!inscricao.dataHoraPagamento) return false;
              
              const dataPagamento = new Date(inscricao.dataHoraPagamento);
              return dataPagamento >= dataInicio && dataPagamento <= dataFim;
            });
          }
          
          // Calcular totais baseados nas inscrições filtradas
          let valorTotal = 0;
          let valorPago = 0;
          let valorPix = 0;
          let valorCartao = 0;
          let valorBoleto = 0;
          let qtdPix = 0;
          let qtdCartao = 0;
          let qtdBoleto = 0;
          
          inscricoes.forEach(inscricao => {
            if (inscricao.statusPagamento === 'PAGO') {
              const valor = parseFloat(inscricao.valor || 0);
              valorTotal += valor;
              valorPago += valor;
              
              // Contabilizar por forma de pagamento
              if (inscricao.formaPagamento) {
                if (inscricao.formaPagamento.includes('PIX')) {
                  valorPix += valor;
                  qtdPix++;
                } else if (inscricao.formaPagamento.includes('Cartão') || 
                           inscricao.formaPagamento.includes('Cartao') || 
                           inscricao.formaPagamento.includes('CARTAO')) {
                  valorCartao += valor;
                  qtdCartao++;
                } else if (inscricao.formaPagamento.includes('Boleto') || 
                           inscricao.formaPagamento.includes('BOLETO')) {
                  valorBoleto += valor;
                  qtdBoleto++;
                }
              }
            } else if (inscricao.statusPagamento === 'PENDENTE') {
              valorTotal += parseFloat(inscricao.valor || 0);
            }
          });
          
          this.valorTotal = valorTotal;
          this.valorPago = valorPago;
          this.valorPendente = valorTotal - valorPago;
          
          // Calcular percentuais
          this.percentValorPago = this.valorTotal > 0 ? (this.valorPago / this.valorTotal) * 100 : 0;
          this.percentValorPendente = this.valorTotal > 0 ? (this.valorPendente / this.valorTotal) * 100 : 0;
          
          // Dados para o gráfico de formas de pagamento
          this.formasPagamento = [];
          
          // Adicionar apenas formas de pagamento que realmente têm transações
          if (valorPix > 0 && qtdPix > 0) {
            this.formasPagamento.push({ tipo: 'PIX', valor: valorPix, quantidade: qtdPix });
          }
          
          if (valorCartao > 0 && qtdCartao > 0) {
            this.formasPagamento.push({ tipo: 'Cartão', valor: valorCartao, quantidade: qtdCartao });
          }
          
          if (valorBoleto > 0 && qtdBoleto > 0) {
            this.formasPagamento.push({ tipo: 'Boleto', valor: valorBoleto, quantidade: qtdBoleto });
          }
        }
      } catch (error) {
        // Fallback: se houver erro, tentar usar os dados que já temos
        try {
          // Estimar valores com base nas inscrições existentes
          const valorMedio = 150; // Valor médio estimado por inscrição
          this.valorTotal = this.inscritos * valorMedio;
          this.valorPago = this.inscritosPagos * valorMedio;
          this.valorPendente = this.valorTotal - this.valorPago;
          
          // Calcular percentuais
          this.percentValorPago = this.valorTotal > 0 ? (this.valorPago / this.valorTotal) * 100 : 0;
          this.percentValorPendente = this.valorTotal > 0 ? (this.valorPendente / this.valorTotal) * 100 : 0;
          
          // Inicializar array vazio
          this.formasPagamento = [];
          
          // Criar distribuição de pagamentos simulada, somente adicionando se houver valores
          if (this.inscritosPagos > 0) {
            const pixPercent = 60; // 60% via PIX
            const cardPercent = 40; // 40% via cartão
            
            const valorPix = (this.valorPago * pixPercent / 100);
            const qtdPix = Math.round(this.inscritosPagos * pixPercent / 100);
            if (valorPix > 0 && qtdPix > 0) {
              this.formasPagamento.push({ 
                tipo: 'PIX', 
                valor: valorPix, 
                quantidade: qtdPix 
              });
            }
            
            const valorCartao = (this.valorPago * cardPercent / 100);
            const qtdCartao = Math.round(this.inscritosPagos * cardPercent / 100);
            if (valorCartao > 0 && qtdCartao > 0) {
              this.formasPagamento.push({ 
                tipo: 'Cartão', 
                valor: valorCartao, 
                quantidade: qtdCartao 
              });
            }
          }
        } catch (fallbackError) {
          // console.error('Erro ao gerar dados de fallback:', fallbackError);
        }
      }
      
      // Atualizar o gráfico de pagamentos após carregar os dados
      this.atualizarGraficoPagamentos();
    },
    
    atualizarGraficoPagamentos() {
      if (this.valorPago <= 0 || this.formasPagamento.length === 0) return;
      
      // Definir valores padrão para as variáveis CSS
      let pixPercent = 0;
      let cardPercent = 0;
      
      // Encontrar os percentuais para cada tipo de pagamento que existe
      for (let i = 0; i < this.formasPagamento.length; i++) {
        const forma = this.formasPagamento[i];
        if (forma.tipo === 'PIX') {
          pixPercent = (forma.valor / this.valorPago * 100);
        } else if (forma.tipo === 'Cartão') {
          cardPercent = (forma.valor / this.valorPago * 100);
        }
      }
      
      // Definir variáveis CSS para criar o gráfico de pizza com conic-gradient
      document.documentElement.style.setProperty('--pix-color', '#0CCE6B');
      document.documentElement.style.setProperty('--card-color', '#2962ff');
      document.documentElement.style.setProperty('--boleto-color', '#f57f17');
      document.documentElement.style.setProperty('--pix-percent', `${pixPercent}%`);
      document.documentElement.style.setProperty('--card-percent', `${cardPercent}%`);
    },
    
    showSnackbarDuplicado(text, color = 'success') {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },
    
    // Chamado no mounted e quando um evento é selecionado
    async carregaValoresDuplicado() {
      this.carregandoDados = true;
      this.quantidadeComposicao = [];
      this.checkinsRealizados = 0; // Inicializar a variável para evitar NaN
      
      let eventoSelecionadoId = typeof this.eventoId === 'object' ? this.eventoId.id : this.eventoId;

      for (var key in this.eventos) {
        if (this.eventos.hasOwnProperty(key)) {
          if (this.eventos[key].id == eventoSelecionadoId) {
            this.capacidade = this.eventos[key].vagas;
            this.reservados = this.eventos[key].reserva || 0; // Garante que seja 0 quando null ou undefined
            this.eventoSelecionado = this.eventos[key];
          }
        }
      }

      // Obter a quantidade de inscrições realizadas e pagas
      await axios.post(`${baseApiUrl}inscricoes/dashboard?access_token=${sessionStorage.getItem("accToken")}`, { eventoId: eventoSelecionadoId })
        .then((res) => {
          this.inscritos = res.data.inscritos ? res.data.inscritos : 0;
          this.inscritosPagos = res.data.confirmados ? res.data.confirmados : 0;
          this.qtdIngressosFisicos = res.data.fisicos ? res.data.fisicos : 0;
          this.qtdIngressosFisicosCortesia = res.data.cortesiaFisica ? res.data.cortesiaFisica : 0;
        });

      try {
        this.checkinsRealizadosTotal = 0;
        let res = await axios.get(`${baseApiUrl}inscricoes?filter={"where":{"eventoId":"${eventoSelecionadoId}"}}&access_token=${sessionStorage.getItem("accToken")}`);
        let inscricoes = res.data;

        if (this.eventoSelecionado.composicao && this.eventoSelecionado.composicao.length) {
          // Se o filtro de período estiver ativo, usar apenas inscrições filtradas para a composição
          if (this.dataInicioFiltro && this.dataFimFiltro && this.periodoFiltro !== 'todos') {
            const dataInicio = new Date(this.dataInicioFiltro);
            const dataFim = new Date(this.dataFimFiltro);
            
            // Filtrar apenas inscrições pagas no período para a composição
            const inscricoesFiltradas = inscricoes.filter(inscricao => {
              if (!inscricao.dataHoraPagamento) return false;
              
              const dataPagamento = new Date(inscricao.dataHoraPagamento);
              return dataPagamento >= dataInicio && dataPagamento <= dataFim;
            });
            
            this.quantidadeComposicao = this.calculaQuantidadesComposicao(inscricoesFiltradas);
          } else {
            // Sem filtro, usar todas as inscrições
            this.quantidadeComposicao = this.calculaQuantidadesComposicao(inscricoes);
          }
        }

        //this.checkinsRealizados = res.data
        inscricoes.forEach((inscrito) => {
          if (this.eventoSelecionado.tipo == 'MESA') {
            for (let i = 0; i < inscrito.vagas.length; i++) {
              if (inscrito.vagas[i].userValidatorCheckinId && inscrito.vagas[i].userValidatorCheckinId.length > 0) {
                this.checkinsRealizadosTotal += inscrito.vagas[i].userValidatorCheckinId.length
                this.checkinsRealizados += this.carregaQuantidades(inscrito.vagas[i].userValidatorCheckinId)
              }
            }
          } else if (this.eventoSelecionado.tipo == 'MULTIPLOS') {
            for (let i = 0; i < inscrito.vagas.length; i++) {
              if (inscrito.vagas[i].userValidatorCheckinId && inscrito.vagas[i].userValidatorCheckinId.length > 0) {
                this.checkinsRealizadosTotal += inscrito.vagas[i].userValidatorCheckinId.length
                this.checkinsRealizados += this.carregaQuantidades(inscrito.vagas[i].userValidatorCheckinId)
              }
            }
          } else {
            if (inscrito.checkin != null && inscrito.hasOwnProperty("composicao")) {
              for (let f = 0; f < inscrito.composicao.length; f++) {
                // Converte quantidade para número antes de somar
                this.checkinsRealizadosTotal += Number(inscrito.composicao[f].quantidade);
              }
              return;
            }
            if (inscrito.checkin != null && inscrito.userValidatorCheckinId == this.user.id) {
              if (inscrito.hasOwnProperty("participantes") && inscrito.participantes > 0)
                this.checkinsRealizados = this.checkinsRealizados + inscrito.participantes;
              else
                this.checkinsRealizados++;
            }
            if (inscrito.checkin != null) {
              if (inscrito.hasOwnProperty("participantes") && inscrito.participantes > 0)
                this.checkinsRealizadosTotal = this.checkinsRealizadosTotal + inscrito.participantes;
              else
                this.checkinsRealizadosTotal++;
            }
          }
        });
      } catch (error) {
        // Tratamento silencioso do erro
        this.showSnackbarDuplicado && this.showSnackbarDuplicado("Erro ao processar dados de check-in", "error");
      } finally {
        this.carregandoDados = false;
      }
      
      // Carregar dados de pagamento
      await this.carregaDadosPagamento();
      
      await this.calculaPercentuais();
      this.recarregaInterface();
    },
    aplicarFiltroPeriodo() {
      // Resetar o filtro de datas personalizado se não estiver no modo personalizado
      if (this.periodoFiltro !== 'personalizado') {
        this.datasFiltro = [];
        this.exibirPeriodoPersonalizado = 'Selecione as datas';
        this.menuData = false;
        
        const hoje = new Date();
        // Declarar todas as variáveis antes do switch para evitar erro de lint
        let inicioHoje, fimHoje, inicioSemana, fimSemana, inicioMes, fimMes;
        
        // Configurar dataInicio e dataFim com base no filtro selecionado
        switch(this.periodoFiltro) {
          case 'hoje':
            // Início do dia atual
            inicioHoje = new Date(hoje);
            inicioHoje.setHours(0, 0, 0, 0);
            this.dataInicioFiltro = inicioHoje.toISOString();
            
            // Fim do dia atual
            fimHoje = new Date(hoje);
            fimHoje.setHours(23, 59, 59, 999);
            this.dataFimFiltro = fimHoje.toISOString();
            break;
            
          case 'semana':
            // Início da semana atual (domingo)
            inicioSemana = new Date(hoje);
            inicioSemana.setDate(hoje.getDate() - hoje.getDay());
            inicioSemana.setHours(0, 0, 0, 0);
            this.dataInicioFiltro = inicioSemana.toISOString();
            
            // Fim da semana atual (sábado)
            fimSemana = new Date(hoje);
            fimSemana.setDate(hoje.getDate() + (6 - hoje.getDay()));
            fimSemana.setHours(23, 59, 59, 999);
            this.dataFimFiltro = fimSemana.toISOString();
            break;
            
          case 'mes':
            // Início do mês atual
            inicioMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
            inicioMes.setHours(0, 0, 0, 0);
            this.dataInicioFiltro = inicioMes.toISOString();
            
            // Fim do mês atual
            fimMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
            fimMes.setHours(23, 59, 59, 999);
            this.dataFimFiltro = fimMes.toISOString();
            break;
            
          case 'todos':
          default:
            // Remover filtro de data
            this.dataInicioFiltro = null;
            this.dataFimFiltro = null;
            break;
        }
      }
      
      // Recarregar os dados com o novo filtro
      this.carregaValores();
    },
    
    atualizarPeriodoPersonalizado() {
      // Para período personalizado, verificar se há duas datas selecionadas
      if (this.periodoFiltro === 'personalizado') {
        if (this.datasFiltro.length === 2) {
          // Formatar data para exibição
          const dataInicio = this.formatarDataParaExibicao(this.datasFiltro[0]);
          const dataFim = this.formatarDataParaExibicao(this.datasFiltro[1]);
          this.exibirPeriodoPersonalizado = `${dataInicio} a ${dataFim}`;
          
          // Configurar datas para o filtro
          // Definir início do dia (00:00:00) para a data inicial
          const dataInicioObj = new Date(this.datasFiltro[0]);
          dataInicioObj.setHours(0, 0, 0, 0);
          this.dataInicioFiltro = dataInicioObj.toISOString();
          
          // Definir fim do dia (23:59:59) para a data final
          const dataFimObj = new Date(this.datasFiltro[1]);
          dataFimObj.setHours(23, 59, 59, 999);
          this.dataFimFiltro = dataFimObj.toISOString();
        }
      } else {
        // Para os outros períodos, aplicar o filtro diretamente
        this.aplicarFiltroPeriodo();
      }
      
      // Recarregar os dados com o novo filtro
      this.carregaValores();
    },
    
    formatarDataParaExibicao(dataString) {
      if (!dataString) return '';
      
      const partes = dataString.split('-');
      if (partes.length !== 3) return dataString;
      
      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    },
    
    limparFiltro() {
      this.periodoFiltro = 'todos';
      this.datasFiltro = [];
      this.dataInicioFiltro = null;
      this.dataFimFiltro = null;
      this.exibirPeriodoPersonalizado = 'Selecione as datas';
      this.menuData = false;
      
      // Recarregar os dados sem filtro
      this.carregaValores();
    },
    selecionarPeriodo(periodo) {
      this.periodoFiltro = periodo;
      this.menuFiltro = false;
      this.atualizarPeriodoPersonalizado();
    },
    getPeriodIcon(periodo) {
      const icons = {
        'todos': 'mdi-filter-outline',
        'hoje': 'mdi-calendar-today',
        'semana': 'mdi-calendar-week',
        'mes': 'mdi-calendar-month',
        'personalizado': 'mdi-calendar-range'
      };
      return icons[periodo] || 'mdi-filter';
    },
  },
};
</script>

<style scoped>
.dashboard-container {
  background-color: #f8f9fa;
  background-image: linear-gradient(to bottom right, rgba(248, 249, 250, 0.9), rgba(233, 236, 239, 0.9));
  min-height: 100vh;
  transition: background-color 0.3s ease;
}

/* Cores para modo escuro */
:deep(.theme--dark) .dashboard-container {
  background-color: #121212;
  background-image: linear-gradient(to bottom right, rgba(18, 18, 18, 0.98), rgba(29, 29, 35, 0.95));
}

.max-width-300 {
  max-width: 300px;
}

.v-card {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: 12px !important;
  overflow: hidden;
}

.v-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.1) !important;
}

:deep(.theme--dark) .v-card {
  background-color: #1e1e1e !important;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
}

:deep(.theme--dark) .v-card:hover {
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.3) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: #252530 !important;
}

.v-progress-linear {
  border-radius: 8px;
  height: 6px !important;
  margin-top: 4px;
  margin-bottom: 4px;
}

.v-avatar {
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.v-card:hover .v-avatar {
  transform: scale(1.1) rotate(5deg);
}

.v-sparkline {
  height: 220px;
  padding: 16px 0;
  overflow: visible !important;
}

/* Melhorias para as legendas do gráfico */
.caption.font-weight-medium {
  font-size: 0.85rem !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Container para chips e legendas */
.v-chip.v-size--small {
  height: 24px;
  font-size: 0.75rem;
  font-weight: 600;
}

/* Espaçamento melhorado para legendas */
.text-center .v-chip + p {
  margin-top: 6px !important;
}

/* Garantir que o gráfico não fique cortado */
.v-card-text .v-sparkline {
  margin-bottom: 16px;
}

.v-progress-circular {
  margin: 0 auto;
  display: block;
  transition: all 0.3s ease;
}

.v-progress-circular:hover {
  transform: scale(1.05);
}

/* Efeitos de hover nos botões */
.v-btn {
  letter-spacing: 0.5px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.3s ease;
}

.v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1) !important;
}

.v-btn.primary, .v-btn.success, .v-btn.info, .v-btn.warning, .v-btn.error {
  transition: all 0.3s ease;
}

/* Cores de destaque personalizadas */
:deep(.theme--light) .primary--text {
  color: #5D4FEB !important;
}

:deep(.theme--light) .v-btn.primary {
  background-color: #5D4FEB !important;
}

:deep(.theme--light) .success--text {
  color: #0CCE6B !important;
}

:deep(.theme--light) .v-btn.success {
  background-color: #0CCE6B !important;
}

:deep(.theme--light) .info--text {
  color: #2196f3 !important;
}

:deep(.theme--light) .v-btn.info {
  background-color: #2196f3 !important;
}

:deep(.theme--light) .warning--text {
  color: #FF9800 !important;
}

:deep(.theme--light) .v-btn.warning {
  background-color: #FF9800 !important;
}

:deep(.theme--light) .error--text {
  color: #f44336 !important;
}

:deep(.theme--light) .v-btn.error {
  background-color: #f44336 !important;
}

/* Estilos de texto aprimorados */
.text-h4 {
  font-weight: 700 !important;
  letter-spacing: -0.5px;
}

.text-subtitle-1 {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);
}

:deep(.theme--dark) .text-subtitle-1 {
  color: rgba(255, 255, 255, 0.85);
}

.text-subtitle-2 {
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 0.8rem !important;
}

/* Responsividade */
@media (max-width: 600px) {
  .dashboard-container {
    padding: 16px !important;
  }
  
  .text-h4 {
    font-size: 1.5rem !important;
  }
  
  .text-h5 {
    font-size: 1.25rem !important;
  }
  
  .v-card {
    margin-bottom: 16px;
  }
}

/* Animações */
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.pulse-animation {
  animation: pulse 2s infinite;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeIn 0.5s ease-out forwards;
}

/* Cards com gradientes elegantes */
.theme--light .purple-gradient {
  background: linear-gradient(45deg, #5D4FEB, #8A7EFF);
  color: white;
}

.theme--light .amber-gradient {
  background: linear-gradient(45deg, #FF9800, #FFBF46);
  color: white;
}

.theme--light .green-gradient {
  background: linear-gradient(45deg, #0CCE6B, #4AE68C);
  color: white;
}

.theme--light .blue-gradient {
  background: linear-gradient(45deg, #2196f3, #4DABF5);
  color: white;
}

/* Versões escuras dos gradientes */
.theme--dark .purple-gradient {
  background: linear-gradient(45deg, #4A3ED9, #7A6BF5);
  box-shadow: 0 4px 20px rgba(74, 62, 217, 0.4) !important;
}

.theme--dark .amber-gradient {
  background: linear-gradient(45deg, #E68A00, #FFAB1A);
  box-shadow: 0 4px 20px rgba(230, 138, 0, 0.4) !important;
}

.theme--dark .green-gradient {
  background: linear-gradient(45deg, #0AB55D, #39D67B);
  box-shadow: 0 4px 20px rgba(10, 181, 93, 0.4) !important;
}

.theme--dark .blue-gradient {
  background: linear-gradient(45deg, #1A86DB, #3D99E3);
  box-shadow: 0 4px 20px rgba(26, 134, 219, 0.4) !important;
}

/* Sombras e elevações personalizadas */
.elevation-custom-1 {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.06), 0 3px 6px rgba(0, 0, 0, 0.08);
}

.elevation-custom-2 {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.12);
}

/* Tema para o modo escuro */
:deep(.theme--dark) {
  --v-anchor-base: #5D4FEB;
  color-scheme: dark;
}

:deep(.theme--dark) .v-list {
  background-color: #1a1a24 !important;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

:deep(.theme--dark) .v-card__text,
:deep(.theme--dark) .v-card__title {
  color: rgba(255, 255, 255, 0.95) !important;
}

:deep(.theme--dark) .grey--text {
  color: rgba(255, 255, 255, 0.8) !important;
}

:deep(.theme--dark) .grey--text.text--darken-1 {
  color: rgba(255, 255, 255, 0.85) !important;
}

:deep(.theme--dark) .text-subtitle-1 {
  color: rgba(255, 255, 255, 0.85);
}

:deep(.theme--dark) .text-caption {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.theme--dark) .v-divider {
  border-color: rgba(255, 255, 255, 0.1) !important;
}

/* Estilo para dialogos mais elegantes */
.v-dialog .v-card {
  border-radius: 16px !important;
  overflow: hidden;
}

.v-dialog .v-card__title {
  padding: 20px 24px;
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: -0.5px;
}

.v-dialog .v-card__text {
  padding: 12px 24px 24px;
  font-size: 1rem;
}

.v-dialog .v-card__actions {
  padding: 16px 24px;
}

/* Estilos para o seletor de eventos elegante */
.event-selector {
  max-width: 350px;
  margin-left: 16px;
}

.event-selector.v-input--is-focused {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.event-selector .v-input__slot {
  border-radius: 12px !important;
  background: linear-gradient(145deg, rgba(255,255,255,0.9), rgba(240,240,240,0.7)) !important;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  min-height: 50px !important;
  transition: all 0.3s ease;
  padding-right: 12px !important;
  padding-left: 12px !important;
}

/* Ajustando o ícone do prepend */
.event-selector .v-input__prepend-inner {
  margin-top: 12px !important;
}

.event-selector .v-input__prepend-inner .v-icon {
  color: #6a11cb !important;
}

.theme--dark .event-selector .v-input__prepend-inner .v-icon {
  color: #9c7df7 !important;
}

.theme--dark .event-selector .v-input__slot {
  background: linear-gradient(145deg, rgba(50,50,50,0.9), rgba(35,35,35,0.7)) !important;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
}

.event-selector:hover .v-input__slot {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08) !important;
}

.event-selection {
  display: flex;
  align-items: center;
  font-weight: 500;
  max-width: 100%;
  overflow: hidden;
}

.event-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px; /* Reduzido para garantir que caiba */
  font-size: 0.9rem;
  display: inline-block;
  padding-left: 8px;
}

.event-avatar {
  background: linear-gradient(145deg, #6a11cb, #2575fc) !important;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
}

.event-list-item {
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.3s ease;
}

.event-list-item:hover {
  background: rgba(106, 17, 203, 0.05);
  transform: translateX(4px);
}

.event-item-title {
  font-weight: 500;
  letter-spacing: 0.3px;
}

.search-container {
  padding: 8px 16px;
}

.event-search .v-input__slot {
  min-height: 40px !important;
  background: rgba(0, 0, 0, 0.03) !important;
  box-shadow: none !important;
}

.theme--dark .event-search .v-input__slot {
  background: rgba(255, 255, 255, 0.05) !important;
}

.v-menu__content {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
  border-radius: 16px !important;
  overflow: hidden;
}

.theme--dark .v-menu__content {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25) !important;
}

/* Animação para entrada dos itens */
.v-list-item {
  transition: transform 0.2s ease, background-color 0.2s ease;
}

/* Correção para o formatEventDate */
.v-list-item__subtitle {
  display: flex;
  align-items: center;
  font-size: 11px !important;
  opacity: 0.8;
}

/* Ajustes responsivos para o seletor de eventos */
@media (max-width: 600px) {
  .mb-4 {
    margin-bottom: 8px !important;
  }
  
  .event-selector {
    max-width: 100%;
    margin-left: 8px;
  }
  
  .v-chip {
    height: 24px !important;
  }
  
  .v-chip .v-icon {
    font-size: 14px !important;
  }
}

/* Ajuste para telas médias */
@media (min-width: 601px) and (max-width: 960px) {
  .event-selector {
    max-width: 250px;
  }
  
  .event-name {
    max-width: 150px;
  }
}

/* Ajuste para telas grandes */
@media (min-width: 961px) {
  .event-selector {
    max-width: 320px;
  }
  
  .event-name {
    max-width: 200px;
  }
}

/* Estilo para o botão de refresh */
.refresh-events-btn {
  margin-left: -12px !important;
  opacity: 0.7;
  transition: all 0.3s ease;
}

.refresh-events-btn:hover {
  opacity: 1;
  transform: rotate(180deg);
}

:deep(.theme--dark) .v-list-item {
  border-radius: 8px;
  margin: 4px 8px;
}

:deep(.theme--dark) .v-list-item:hover {
  background-color: rgba(93, 79, 235, 0.15) !important;
}

:deep(.theme--dark) .v-list-item--active {
  background-color: rgba(93, 79, 235, 0.25) !important;
}

/* Melhorar elementos de formulário no modo escuro */
:deep(.theme--dark) .v-text-field--outlined > .v-input__control > .v-input__slot,
:deep(.theme--dark) .v-select__slot,
:deep(.theme--dark) .v-input--is-focused > .v-input__control > .v-input__slot {
  border-color: rgba(255, 255, 255, 0.1) !important;
  background-color: rgba(30, 30, 40, 0.5) !important;
}

:deep(.theme--dark) .v-text-field--outlined:hover > .v-input__control > .v-input__slot,
:deep(.theme--dark) .v-select:hover .v-select__slot {
  border-color: rgba(255, 255, 255, 0.2) !important;
}

:deep(.theme--dark) .v-text-field--outlined.v-input--is-focused > .v-input__control > .v-input__slot,
:deep(.theme--dark) .v-select.v-input--is-focused .v-select__slot {
  border-color: #5D4FEB !important;
  box-shadow: 0 0 0 2px rgba(93, 79, 235, 0.2) !important;
}

/* Barra de progresso e chips no modo escuro */
:deep(.theme--dark) .v-chip {
  background-color: #252530 !important;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

:deep(.theme--dark) .v-chip.primary {
  background-color: #5D4FEB !important;
  border: none;
}

:deep(.theme--dark) .v-chip.success {
  background-color: #0CCE6B !important;
  border: none;
}

:deep(.theme--dark) .v-chip.info {
  background-color: #2196f3 !important;
  border: none;
}

:deep(.theme--dark) .v-chip.warning {
  background-color: #FF9800 !important;
  border: none;
}

:deep(.theme--dark) .v-chip.error {
  background-color: #f44336 !important;
  border: none;
}

:deep(.theme--dark) .v-progress-linear {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

/* Efeito sutil de brilho para os cards no modo escuro ao passar o mouse */
:deep(.theme--dark) .v-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 12px;
  box-shadow: 0 0 0 0 rgba(93, 79, 235, 0);
  opacity: 0;
  transition: all 0.5s ease;
  z-index: -1;
  pointer-events: none;
}

:deep(.theme--dark) .v-card:hover::before {
  opacity: 0.3;
  box-shadow: 0 0 15px 5px rgba(93, 79, 235, 0.3);
}

/* Botão de alternar entre claro/escuro com animação */
.v-btn.dark-mode-toggle {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.v-btn.dark-mode-toggle::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5px;
  height: 5px;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0;
  border-radius: 100%;
  transform: scale(1, 1) translate(-50%, -50%);
  transform-origin: 50% 50%;
}

.v-btn.dark-mode-toggle:active::after {
  opacity: 0.3;
  transform: scale(200, 200) translate(-50%, -50%);
  transition: all 1s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Melhorar a navegação no modo escuro */
:deep(.theme--dark) .v-tabs {
  background-color: transparent !important;
}

:deep(.theme--dark) .v-tabs-bar {
  background-color: #1a1a24 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

:deep(.theme--dark) .v-tab {
  color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.theme--dark) .v-tab--active {
  color: #5D4FEB !important;
}

:deep(.theme--dark) .v-tab::before {
  background-color: #5D4FEB;
}

/* Transição de tema */
.theme-transition {
  transition: background-color 0.8s ease, color 0.8s ease, border-color 0.8s ease, box-shadow 0.8s ease !important;
}

.theme-transition * {
  transition: background-color 0.8s ease, color 0.8s ease, border-color 0.8s ease, box-shadow 0.8s ease !important;
}

/* Animação do botão de tema */
.dark-mode-toggle .v-icon {
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.dark-mode-toggle:active .v-icon {
  transform: rotate(360deg);
}

html.dark-mode {
  color-scheme: dark;
}

/* Melhorias específicas para o dashboard no modo escuro */
:deep(.theme--dark) .dashboard-container {
  background-color: #121212;
  background-image: linear-gradient(135deg, 
    rgba(18, 18, 18, 0.99) 0%, 
    rgba(25, 25, 35, 0.99) 50%, 
    rgba(32, 32, 45, 0.99) 100%);
  box-shadow: inset 0 0 100px rgba(0, 0, 0, 0.2);
}

/* Melhorias para textos no modo escuro */
:deep(.theme--dark) .primary--text {
  color: #8a7efd !important;
}

:deep(.theme--dark) .text-h3 {
  color: rgba(255, 255, 255, 0.95) !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Ajustes para uniformidade dos cards */
.card-uniform-height {
  height: 100%;
  min-height: 140px;
  display: flex;
  flex-direction: column;
}

.card-uniform-height .v-card__text {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* Responsividade */
@media (max-width: 600px) {
  .dashboard-container {
    padding: 12px !important;
  }
  
  .cards-grid {
    margin: 0 -4px;
  }
  
  .cards-grid .v-col-6 {
    padding: 4px;
  }
  
  .card-uniform-height {
    min-height: 120px;
  }
  
  .card-uniform-height .v-card__text {
    padding: 12px !important;
  }
  
  .cards-grid .text-h5 {
    font-size: 1.1rem !important;
  }
  
  .cards-grid .text-subtitle-2 {
    font-size: 0.7rem !important;
  }
  
  .cards-grid .caption {
    font-size: 0.65rem !important;
  }
  
  .cards-grid .v-avatar {
    width: 32px !important;
    height: 32px !important;
  }
  
  .cards-grid .v-icon {
    font-size: 18px !important;
  }
}

/* Gradientes dos cards */
.theme--light .teal-gradient {
  background: linear-gradient(45deg, #009688, #4DB6AC);
  color: white;
}

.theme--dark .teal-gradient {
  background: linear-gradient(45deg, #00796B, #26A69A);
  box-shadow: 0 4px 20px rgba(0, 121, 107, 0.4) !important;
}

.header-container {
  max-width: 100%;
  margin: 0 auto;
}

.event-selector {
  width: 100%;
  max-width: 350px;
}

.capacity-chip {
  height: 24px;
}

@media (max-width: 600px) {
  .mb-4 {
    margin-bottom: 16px !important;
  }
  
  .header-container {
    padding: 0 16px;
  }

  .event-selector {
    width: 100%;
    max-width: 100%;
  }
  
  .v-chip {
    height: 24px !important;
  }
  
  .v-chip .v-icon {
    font-size: 14px !important;
  }
}

.deep-purple-gradient {
  background: linear-gradient(45deg, #5e35b1, #7c4dff) !important;
  box-shadow: 0 4px 20px rgba(94, 53, 177, 0.4) !important;
}

.indigo-gradient {
  background: linear-gradient(45deg, #303f9f, #3949ab) !important;
  box-shadow: 0 4px 20px rgba(48, 63, 159, 0.4) !important;
}

.orange-gradient {
  background: linear-gradient(45deg, #e65100, #f57c00) !important;
  box-shadow: 0 4px 20px rgba(230, 81, 0, 0.4) !important;
}

.payment-chart {
  position: relative;
  margin: 0 auto;
  display: block;
}

.inner-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.payment-chart::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 50%;
  background: conic-gradient(
    #0CCE6B 0 var(--pix-percent), 
    #2962ff var(--pix-percent) calc(var(--pix-percent) + var(--card-percent)), 
    #f57f17 calc(var(--pix-percent) + var(--card-percent)) 100%
  );
  z-index: -1;
}

.valor-confirmado-card {
  background: linear-gradient(135deg, rgba(33, 150, 243, 0.05) 0%, rgba(33, 150, 243, 0.1) 100%);
  border-left: 4px solid #2196F3;
  overflow: hidden;
  position: relative;
  transition: all 0.2s ease;
}

.valor-confirmado-card:hover {
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.15) !important;
}

.payment-methods-card {
  background: linear-gradient(135deg, rgba(33, 150, 243, 0.02) 0%, rgba(33, 150, 243, 0.06) 100%);
  border-left: 4px solid rgba(33, 150, 243, 0.5);
  overflow: hidden;
  position: relative;
  transition: all 0.2s ease;
}

.payment-methods-card:hover {
  box-shadow: 0 3px 10px rgba(33, 150, 243, 0.1) !important;
}

.eye-btn {
  opacity: 0.5;
  transition: opacity 0.3s, transform 0.3s;
  &:hover {
    opacity: 1;
    transform: scale(1.1);
  }
}

.blue-divider {
  border-color: rgba(33, 150, 243, 0.2) !important;
}

.payment-method-item {
  padding: 12px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.payment-method-item:hover {
  background-color: rgba(33, 150, 243, 0.05);
}

.hide-values-btn {
  position: absolute !important;
  top: 8px;
  right: 8px;
  z-index: 2;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.hide-values-btn:hover {
  opacity: 1;
}

.compact-card {
  min-height: auto !important;
  margin-bottom: 2px;
}

.cards-grid {
  margin-top: 0;
  margin-bottom: 8px;
}

.cards-grid .v-card {
  transition: all 0.2s ease;
}

.cards-grid .v-card:hover {
  transform: translateY(-2px);
}

/* Gradientes para os cards */
.deep-purple-gradient {
  background: linear-gradient(45deg, #5e35b1, #7c4dff) !important;
  box-shadow: 0 4px 20px rgba(94, 53, 177, 0.4) !important;
}

.indigo-gradient {
  background: linear-gradient(45deg, #303f9f, #3949ab) !important;
  box-shadow: 0 4px 20px rgba(48, 63, 159, 0.4) !important;
}

.orange-gradient {
  background: linear-gradient(45deg, #e65100, #f57c00) !important;
  box-shadow: 0 4px 20px rgba(230, 81, 0, 0.4) !important;
}

.eye-btn {
  opacity: 0.5;
  transition: opacity 0.3s, transform 0.3s;
  &:hover {
    opacity: 1;
    transform: scale(1.1);
  }
}

.blue-divider {
  border-color: rgba(33, 150, 243, 0.2) !important;
}

.blue-divider {
  background-color: rgba(33, 150, 243, 0.2);
  height: 1px;
}

.pix-icon {
  padding: 0;
  max-width: 60%;
  max-height: 60%;
  object-fit: contain;
  display: block;
  margin: auto;
}

.pix-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
}

.period-filter-chip {
  font-weight: 500 !important;
  height: 36px !important;
  padding: 0 16px !important;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1) !important;
  background-color: #2196f3 !important;
  color: white !important;
  border: none !important;
}

.period-filter-chip:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-1px) !important;
}

.period-filter-chip.v-chip--outlined {
  background-color: transparent !important;
  color: #757575 !important;
  border: 1px solid #e0e0e0 !important;
}

.theme--dark .period-filter-chip {
  background-color: rgba(33, 150, 243, 0.7) !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2) !important;
}

.theme--dark .period-filter-chip:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3) !important;
}

.theme--dark .period-filter-chip.v-chip--outlined {
  background-color: transparent !important;
  color: #bdbdbd !important;
  border: 1px solid #616161 !important;
}

.v-list-item.selected-period {
  background-color: rgba(33, 150, 243, 0.08) !important;
  border-radius: 8px !important;
}

.theme--dark .v-list-item.selected-period {
  background-color: rgba(33, 150, 243, 0.15) !important;
}

/* Divider azul para o filtro de período */
.blue-divider {
  border-color: var(--v-primary-base) !important;
  opacity: 0.7;
}
</style>
